{
  "Actions": {
    "actions": "Azioni",
    "back": "Indietro",
    "click here": "Clicca qui",
    "collapse": "Chiudi",
    "expand": "Espandi",
    "go to vehicle": "Vai al veicolo"
  },
  "Alert": {
    "Account is already activated": "L'account è già attivato.",
    "action failed": "Operazione non riuscita a causa di un errore",
    "add company card success": "Nuova carta aziendale aggiunta con successo.",
    "add driver success": "Autista aggiunto con successo",
    "add integration success": "Integrazione creata con successo.",
    "add vehicle empty imei info": {
      "description": "Al veicolo non è stato assegnato alcun IMEI e non sarà in grado di scaricare i file. Aggiungere un IMEI valido per scaricare i file del veicolo.",
      "title": "Veicolo aggiunto con successo, ma nessun IMEI assegnato."
    },
    "add vehicle success": "Veicolo aggiunto con successo",
    "An unhandled error occured while processing this request": "Si è verificato un errore non gestito durante l'elaborazione di questa richiesta.",
    "Another driver is registered under this card number.": "Un altro conducente è registrato con questo numero di carta.",
    "apply all driver schedules success": "Pianificazione aggiunta con successo a tutti i conducenti",
    "apply all vehicle schedules success": "Pianificazione aggiunta con successo a tutti i veicoli",
    "apply driver schedules success": "Pianificazione aggiunta con successo a {{resourceCount}} autisti",
    "apply vehicle schedules success": "Pianificazione aggiunta con successo a {{resourceCount}} veicoli",
    "cancel invitation success": "Invito cancellato con successo.",
    "Card number must be 16 characters in length.": "L'ID autista deve essere composto da 16 caratteri.",
    "CCA file download success": "Company Card Authenticator è stato scaricato correttamente.",
    "Comment must not be longer than 255 characters.": "Il numero massimo di caratteri consentiti per la descrizione è 255.",
    "Company card with such ID already exists.": "Esiste già una carta aziendale con questo ID.",
    "Company card with such name already exists.": "Esiste già una scheda aziendale con questo nome.",
    "Company not found": "Azienda non trovata.",
    "Company not found.": "Azienda non trovata.",
    "Company with this LZ client code already exists.": "Esiste già un'azienda con questo codice Teltonika.",
    "create client company success": "Nuova azienda cliente creata con successo.",
    "create company success": "Azienda creata con successo.",
    "create schedule success": "Nuova pianificazione creata con successo.",
    "credits overdraft activated": "Fido attivato con successo",
    "credits overdraft deactivated": "Fido disattivato con successo",
    "disable integration success": "Integrazione disabilitata con successo.",
    "Driver duplication.": "Duplicazione autista.",
    "Driver name contains invalid characters.": "Il nome dell'autista contiene caratteri non validi.",
    "Driver name must be 3-50 characters long.": "Il nome dell'autista deve contenere da 3 a 50 caratteri.",
    "Driver with such card number already exists.": "L'ID autista esiste già.",
    "Drivers schedules were not found": "Non sono stati trovati i turni dei conducenti.",
    "edit company card success": "Scheda aziendale modificata con successo.",
    "edit integration success": "Integrazione modificata con successo.",
    "edit schedule success": "Pianificazione modificata con successo.",
    "edit user description": "Le modifiche entreranno in vigore dopo che l'utente che ha apportato le modifiche avrà effettuato il logout.",
    "Email recipient was not found.": "Il destinatario dell'e-mail non è stato trovato.",
    "email transfer edit recipient success": "Il destinatario dell'e-mail è stato modificato con successo.",
    "email transfer new recipient success": "Il destinatario dell'e-mail è stato aggiunto con successo.",
    "email transfer remove recipient success": "Il destinatario dell'e-mail è stato rimosso con successo.",
    "enable integration success": "Integrazione abilitata con successo.",
    "error": {
      "import failed": "Impossibile importare il file. Rimuovere il file, assicurarsi che i dati corrispondano alla struttura richiesta e caricare nuovamente il file.",
      "import failed description": "Elimina il file, assicurati che i dati corrispondano alla struttura richiesta e carica nuovamente il file.",
      "import failed title": "Importazione non riuscita. I dati non corrispondono alla struttura del file."
    },
    "general settings update success": "Impostazioni modificate con successo.",
    "global schedule success": "Pianificazione totale create con successo",
    "Id must be of digits and letters only": "L'ID deve essere composto esclusivamente da cifre e lettere",
    "Id must be of length 6 to 8": "L'ID deve avere una lunghezza compresa tra 6 e 8 caratteri",
    "Imei must be 15 characters long.": "L'IMEI deve essere composto da 15 caratteri.",
    "Imei must be numeric.": "Per il campo IMEI sono ammessi solo valori numerici.",
    "integration editing cancelled": "Modifica dell'integrazione annullata.",
    "Integration is disabled. Enable it first before retrying": "L'integrazione è disabilitata. Abilitala prima di riprovare.",
    "Invalid email address": "Indirizzo e-mail non valido.",
    "Invalid format.": "Formato del file non valido",
    "LZ client code not found.": "Codice Teltonika non trovato.",
    "move company success": "La società \"{{sourceCompany}}\" è stata trasferita con successo a \"{{targetCompany}}\".",
    "New name must be different from the current name.": "Il nuovo nome deve essere diverso da quello attuale.",
    "news created": "Notizia creata con successo.",
    "news deleted": "Notizia eliminata con successo.",
    "news edited": "Notizia modificata con successo.",
    "news published": "Notizia pubblicata con successo.",
    "Number must be provided.": "È necessario fornire il numero.",
    "Number must not be longer than 30 characters.": "Il numero massimo di caratteri consentito per il numero di targa è 30.",
    "One or more selected companies have child companies and cannot be deleted.": "Una o più aziende selezionate hanno sotto-aziende e non possono essere eliminate.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "Si sono verificati uno o più errori di convalida durante l'analisi del file CSV. Si prega di utilizzare il file modello come riferimento.",
    "One or more validation errors occured.": "Si sono verificati uno o più errori di convalida.",
    "quick schedule created": {
      "description": {
        "drivers": "Il download dei dati verrà avviato non appena verrà rilevata la connessione del conducente a TachoSync.",
        "vehicles": "Il download dei dati verrà avviato non appena verrà rilevata la connessione del veicolo a TachoSync."
      },
      "title": "Pianificazione rapida creata con successo",
      "title multiple drivers": "Pianificazione rapida creata con successo per {{driverNum}} autisti.",
      "title multiple vehicles": "Pianificazione rapida creata con successo per {{vehicleNum}} veicoli.",
      "title single driver": "Pianificazione rapida creata con successo"
    },
    "Quick schedule for vehicle is already created.": "La pianificazione rapida per il veicolo è già stata creata.",
    "Quick schedule is already assigned to the driver.": "La pianificazione rapida per il veicolo è già stata assegnata all'autista.",
    "remove company card success": "Carta aziendale rimossa con successo.",
    "resend invitation success": "L'invito è stato reinviato con successo.",
    "retry integration success": "Integrazione \"{{integrationName}}\" connessa con successo.",
    "retry interrupted integration success": "L'integrazione \"{{integrationName}}\" riproverà a sincronizzare i file saltati. Torna più tardi per verificare lo stato.",
    "session expired": "La tua sessione è terminata. Effettua nuovamente l'accesso.",
    "successfully activate vehicle multiple": "{{resourceString}} veicoli attivati con successo.",
    "successfully activate vehicle single": "Veicolo attivato con successo.",
    "successfully assigned schedules": {
      "multiple": "Orari assegnati con successo.",
      "single": "Programma assegnato con successo."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} veicoli disattivati con successo.",
    "successfully deactivate vehicle single": "Veicolo disattivato con successo.",
    "successfully deleted": "{{resourceString}} eliminato con successo.",
    "successfully edited": "{{resourceString}} modificato con successo.",
    "successfully exported": "$t(General##{{tableName}}) esportato con successo.",
    "successfully imported": "{{resourceString}} importato con successo.",
    "successfully move vehicles multiple": "{{resourceString}} sono stati trasferiti con successo a {{companyString}}.",
    "successfully move vehicles single": "{{resourceString}} è stato trasferito con successo a {{companyString}}.",
    "successfully remove driver schedules multiple": "Gli orari sono stati rimossi con successo dai driver {{resourceString}}.",
    "successfully remove driver schedules single": "Gli orari sono stati rimossi con successo dal driver {{resourceString}}.",
    "successfully remove vehicle schedules multiple": "Gli orari sono stati rimossi con successo dai veicoli {{resourceString}}.",
    "successfully remove vehicle schedules single": "Gli orari sono stati rimossi con successo dal veicolo {{resourceString}}.",
    "successfully removed": "{{resourceString}} rimosso con successo.",
    "The company with such name already exists.": "Esiste già un'azienda con questo nome.",
    "User is already invited.": "L'utente è già stato invitato.",
    "User is not invited": "L'utente non è stato invitato.",
    "Vehicle duplication.": "Duplicazione veicoli.",
    "Vehicle number contains invalid characters.": "Il numero del veicolo contiene caratteri non validi.",
    "Vehicle schedule was not found": "Non è stata trovata alcuna pianificazione del veicolo",
    "Vehicle successfully activated": "Veicolo attivato con successo.",
    "Vehicle with such IMEI already exists.": "Il veicolo con quell'IMEI esiste già",
    "Vehicle with such Imei number already exists.": "L'IMEI esiste già.",
    "Vehicle with such number (VRN) already exists.": "Esiste già un veicolo con quel numero di immatricolazione",
    "Vehicles schedules were not found": "Non sono state trovate le pianificazioni dei veicoli.",
    "You cannot delete a company you are a member of.": "Non è possibile eliminare un'azienda attualmente selezionata. Selezionare un'altra azienda e ripetere l'operazione."
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Controlla la tua app di autenticazione",
      "check email": "Controlla la tua e-mail",
      "code required": "È richiesto un codice di verifica.",
      "code sent to email": "Codice inviato alla tua e-mail",
      "code valid": "Il codice è valido per alcuni minuti.",
      "enter code below": "e inserisci il codice sottostante per effettuare l'accesso."
    },
    "account verification description": "È richiesto un codice di verifica. Controlla la tua app di autenticazione e inserisci il codice qui sotto per accedere.",
    "authenticator": "App di autenticazione",
    "authenticator verification description": "È richiesto un codice di verifica. Controlla la tua app di autenticazione e inserisci il codice qui sotto per accedere.",
    "back to sign in screen": "Torna alla schermata di accesso",
    "check email": "Controlla la tua casella di posta e clicca sul link ricevuto per reimpostare la password.",
    "community forum": "Forum di supporto della community",
    "contact us": "Contattaci",
    "create password": "Crea password",
    "did not receive": "Non hai ricevuto il link?",
    "do not have account": "Non hai ancora un account?",
    "email": "E-mail",
    "enter current password": "Inserisci la password attuale",
    "enter email": "Inserisci qui sotto l'indirizzo e-mail con cui ti sei registrato per ricevere le istruzioni per reimpostare la password.",
    "enter here": "Entra qui",
    "enter new password": "Inserisci una nuova password",
    "enter numbers only": "Inserire solo numeri (0-9)",
    "example": "Es.:",
    "failed to login": "L'indirizzo e-mail o la password inseriti non sono corretti.",
    "forgot password": "Hai dimenticato la password?",
    "forgot your password": "Hai dimenticato la password?",
    "go to login": "Vai al login",
    "google authenticator": "Google Authenticator",
    "hide password": "Nascondi password",
    "invalid email format": "Formato e-mail non valido",
    "invalid password format": "Formato password non valido",
    "Invitation expired": "Il link di invito è scaduto o è stato annullato.",
    "link sent": "Il link è stato inviato!",
    "login title": "Accedi",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "Nuova password",
    "password": "Password",
    "password changed": "Password modificata con successo.",
    "privacy policy": "Utilizzando <1>TachoSync</1>, accetti la nostra <3>Informativa sulla privacy</3>.",
    "remember password": "Ricordi la tua password?",
    "repeat new password": "Conferma nuova password",
    "repeat password": "Conferma password",
    "required": "Obbligatorio",
    "resend": "Invia nuovamente",
    "reset password": "Reimposta password",
    "send reset link": "Invia link di ripristino",
    "show password": "Mostra password",
    "sign in": "Accedi",
    "sign in to tacho": "Accedi al tuoaccount TachoSync",
    "sign out": "Esci",
    "sign up": "Iscriviti",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "Ho letto e accetto i <1>Termini di servizio</1> di Teltonika e l'<2>Accordo sul </2>trattamento dei dati.",
    "wiki": "Telematics Wiki Info di Base"
  },
  "Button": {
    "accept": "Accetta",
    "accept all": "Accetta tutto",
    "accept selected": "Accetta i selezionati",
    "actions": "Azioni",
    "activate": "Attiva",
    "add": "Aggiungi",
    "add driver": "Aggiungi autista",
    "add integration": "Aggiungi integrazione",
    "add to schedule": "Aggiungi al calendario",
    "add vehicle": "Aggiungi veicolo",
    "all drivers": "Tutti i conducenti",
    "all vehicles": "Tutti i veicoli",
    "apply": "Applica",
    "assign": "Assegna",
    "back": "Indietro",
    "back to sign in": "Torna a Accedi",
    "cancel": "Annulla",
    "change": "Modifica",
    "child company": "Società controllata",
    "clear": "Cancella",
    "clear all": "Cancella tutto",
    "close": "Chiudi",
    "confirm": "Conferma",
    "continue": "Continua",
    "continue to TachoSync": "Continua su TachoSync",
    "copied": "Copiato",
    "copy to clipboard": "Copia negli appunti",
    "create": "Crea",
    "create schedule": "Crea pianificazione",
    "deactivate": "Disattiva",
    "default view": "Visualizzazione predefinita",
    "delete": "Elimina",
    "deselect all": "Deseleziona tutto",
    "disable": "Disattiva",
    "don't apply": "Non applicare",
    "download": "Scarica",
    "edit": "Modifica",
    "edit driver": "Modifica autista",
    "edit integration": "Modifica integrazione",
    "edit vehicle": "Modifica veicolo",
    "enable": "Abilita",
    "export": "Esporta",
    "export drivers": "Esportazione autisti",
    "export vehicles": "Esportazione veicoli",
    "file settings": "Impostazioni file",
    "filtered": "Filtrato",
    "filters": "Filtri",
    "find device": "Trova dispositivo",
    "finish": "Fine",
    "first page": "Prima pagina",
    "generate": "Genera",
    "generate report": "Genera report",
    "get started": "Inizia",
    "go back": "Torna indietro",
    "import": "Importa",
    "import drivers": "Importa autisti",
    "import vehicles": "Veicoli importati",
    "inline actions": {
      "cancel invitation": "Annulla invito",
      "download file driver": "Scarica",
      "download file vehicle": "Scarica",
      "download monitoring": "Monitoraggio dei download",
      "download status": "Stato del download",
      "edit analysis provider": "Modifica",
      "edit company": "Modifica azienda",
      "edit driver": "Modifica autista",
      "edit integration": "Modifica integrazione",
      "edit user": "Modifica utente",
      "edit vehicle": "Modifica veicolo",
      "resend invitation": "Invia nuovamente l'invito",
      "retry analysis provider": "Riprova",
      "retry integration": "Riprova"
    },
    "invite": "Invita",
    "invite user": "Invita utente",
    "history": "Cronologia",
    "last page": "Ultima pagina",
    "max download files": "È possibile scaricare solo {{maxNumber}} file alla volta.",
    "more actions": "Altre azioni",
    "more filters": "Altri filtri",
    "more options": "Altre opzioni",
    "move": "Sposta",
    "new client": "Nuovo cliente",
    "next": "Successivo",
    "next month": "Il mese prossimo",
    "next page": "Pagina successiva",
    "only essential": "Solo l'essenziale",
    "open TachoSync": "Apri TachoSync",
    "pages of": "di {{total}}",
    "pause": "Pausa",
    "previous": "Precedente",
    "previous month": "Mese precedente",
    "previous page": "Pagina precedente",
    "quick schedule": "Pianificazione rapida",
    "refresh page": "Aggiorna pagina",
    "reject all": "Rifiuta tutto",
    "remove": "Rimuovi",
    "remove schedules": "Rimuovi pianificazioni",
    "reset": "Reimposta",
    "reset to default": "Ripristina impostazioni predefinite",
    "resume": "Continua",
    "return home": "Vai alla pagina inziale ",
    "rows selected": "{{count}} selezionati",
    "save": "Salva",
    "schedules": "Pianificazioni",
    "select image": "Seleziona immagine",
    "select rows": "Seleziona righe",
    "selected": "Selezionato",
    "send code": "Invia codice",
    "settings": "Impostazioni",
    "table view": "Visualizzazione tabella",
    "testing connection": "Verifica della connessione...",
    "verify": "Verifica",
    "yes": "Sì"
  },
  "Company cards": {
    "add new": "Aggiungi nuovo",
    "badge tooltip": {
      "Disconnected": "La connessione a TachoSync è stata interrotta.\nUltima connessione {{connectionDate}}.",
      "Expired": "La carta è stata disattivata perché è scaduta.",
      "Inactive": "Non è mai stata stabilita una connessione con TachoSync.",
      "Online": "Connessione a TachoSync stabilita con successo e comunicazione attiva."
    },
    "card expired": "La carta è scaduta: {{date}}",
    "card id": "ID della carta",
    "card number": "Numero della carta",
    "card number tooltip": "Il numero della carta verrà visualizzato dopo la prima autorizzazione riuscita.",
    "cca version": "Versione CCA",
    "company card id": "ID della carta aziendale",
    "edit card": "Modifica carta",
    "edit company card": "Modifica carta aziendale",
    "expiry": "Scadenza",
    "expiry date": "Data di scadenza: {{date}}",
    "expiry tooltip": "La data di scadenza della carta verrà visualizzata dopo la prima autorizzazione riuscita.",
    "latest version": "Ultime notizie",
    "remove card": "Rimuovi carta",
    "remove company card": "Rimuovere la carta aziendale?",
    "remove company card description": "Sei sicuro di voler rimuovere la carta aziendale “{{cardName}}”? Questa operazione non può essere annullata.",
    "status": "Stato",
    "update version warning": "È disponibile una versione più recente.  Ti consigliamo di aggiornarla per ottenere prestazioni ottimali.",
    "valid until": "Valido fino al",
    "version details after connection is established": "I dettagli sulla versione appariranno qui dopo la prima connessione dalla carta aziendale."
  },
  "Cookies": {
    "accept": "Accetta",
    "always active": "Sempre attivo",
    "analytics cookies": "Cookie di analisi",
    "analytics cookies description": "Questi tracker vengono utilizzati a fini analitici per raccogliere dati che ci consentono di comprendere come gli utenti interagiscono con i nostri siti web. Queste informazioni ci permettono sia di migliorare i contenuti sia di sviluppare funzionalità più efficaci che migliorano l'esperienza dell'utente. Questa categoria di cookie può essere disabilitata.",
    "cookie banner message": "Noi e alcune terze parti selezionate utilizziamo i cookie o tecnologie simili per finalità tecniche e, previo consenso dell'utente, per altre finalità specificate nella <1>politica sui cookie</1>.",
    "cookie modal title": "Utilizziamo i cookie",
    "cookie policy": "politica sui cookie",
    "essential cookies": "Cookie essenziali",
    "essential cookies description": "Questi tracciatori vengono utilizzati per attività strettamente necessarie al funzionamento o alla fornitura del servizio che ci hai richiesto; tali cookie non raccolgono informazioni su di te che potrebbero essere utilizzate per scopi di marketing e non memorizzano i siti che hai visitato su Internet. Questa categoria di cookie non può essere disabilitata.",
    "text": "Questo sito web memorizza dati quali i cookie per consentire il corretto funzionamento del sito, compresa l'analisi dei dati."
  },
  "Dashboard": {
    "added": "Aggiunto",
    "Available": "Disponibile",
    "cards": "Schede",
    "card tooltips": {
      "connectivity": "<strong>Online:</strong>\nIl dispositivo si è connesso nelle ultime 24 ore\n\n<strong>Offline:</strong>\nIl dispositivo non si è connesso nelle ultime 24 ore\n\n<strong>Inattivo:</strong>\nIl dispositivo non ha mai stabilito una connessione con TachoSync",
      "driver downloads": "<strong>Puntuale:</strong>\n0–14 giorni dall'ultimo download\n\n<strong>In scadenza:</strong>\n15–28 giorni dall'ultimo download\n\n<strong>Scaduto:</strong>\n29+ giorni dall'ultimo download\n\n<strong>Nessun download:</strong>\nNon sono stati ancora effettuati download",
      "vehicle downloads": "<strong>Puntuale:</strong>\n0–60 giorni dall'ultimo download\n\n<strong>In scadenza:</strong>\n61–90 giorni dall'ultimo download\n\n<strong>Scaduto:</strong>\n91+ giorni dall'ultimo download\n\n<strong>Nessun download:</strong>\nNon sono stati ancora effettuati download"
    },
    "cc expiry": {
      "expired": "Scaduto",
      "near expiry": "Scadenza imminente",
      "near expiry tooltip": "Scadenza entro 3 mesi",
      "upcoming expiry": "Scadenza imminente",
      "upcoming expiry tooltip": "Scadenza entro 3–6 mesi"
    },
    "company cards": "Carte aziendali",
    "company cards expiration": "Scadenza delle carte aziendali",
    "connectivity": "Connettività",
    "connectivity tabs": {
      "company cards": "Carte aziendali",
      "devices": "Dispositivi"
    },
    "credit overdraft activated": "Scoperto attivato: {{overDraftAmount}} crediti",
    "credits": "Crediti",
    "credits health": {
      "Healthy": "In buona salute",
      "InOverdraft": "In scoperto",
      "LimitReached": "Limite raggiunto",
      "LowCredits": "Crediti insufficienti",
      "OverdraftLimitReached": "Limite raggiunto"
    },
    "credits history": "Cronologia dei crediti",
    "credits history actions": {
      "BonusCredits": "Crediti bonus",
      "CreditsExpiration": "Scadenza dei crediti",
      "Deduction": "Ritenuta mensile",
      "FreeTrial": "Aggiunti crediti demo",
      "MonthlyDeduction": "Ritenuta mensile",
      "Purchase": "Crediti aggiunti",
      "WebTachoLicenseConversion": "Migrazione"
    },
    "credits statuses": {
      "available": "Disponibile",
      "balance": "Saldo",
      "overdraft": "Scoperto di conto",
      "remaining overdraft": "Fido residuo",
      "reserved": "Riservato"
    },
    "Deactivated": "Disattivato",
    "deducted": "Detratto",
    "demo credits": {
      "demo": "Demo",
      "demo credits expired tooltip": "I crediti demo sono scaduti. Acquista dei crediti per continuare a utilizzare TachoSync.",
      "demo credits used up tooltip": "Tutti i crediti demo sono stati utilizzati. Acquista dei crediti per continuare a utilizzare TachoSync.",
      "demo info tooltip": "I crediti demo vengono attivati al primo collegamento IMEI e rimangono attivi per 90 giorni."
    },
    "device status": "Stato del dispositivo",
    "devices": "Dispositivi",
    "driver data": "Dati dei conducenti",
    "driver downloads": "Download dei conducenti",
    "DueSoon": "In scadenza",
    "estimated": "Stimata",
    "expires": "Scadenza",
    "how credits work": {
      "bottom content": {
        "header": "Quando viene riservato un credito?",
        "table": {
          "body": {
            "any": "Qualsiasi",
            "any behaviour": "Nessun nuovo credito. La prenotazione esistente rimane valida fino alla fine del mese.",
            "newly assigned": "Appena assegnato",
            "newly assigned behaviour": "Riservato alla connessione. Migrato al VIN dopo il primo download.",
            "replaced vin known": "Sostituito (numero di telaio noto)",
            "replaced vin known behaviour": "Nessun nuovo credito. La prenotazione esistente rimane valida.",
            "none": "Nessuno",
            "none behaviour": "Nessun credito riservato. I download non inizieranno finché non verrà assegnato un dispositivo."
          },
          "head": {
            "credit behaviour": "Comportamento creditizio",
            "device": "Dispositivo",
            "vehicle status": "Stato del veicolo"
          }
        }
      },
      "button tooltip": "Scopri come funzionano i crediti",
      "main description": "I crediti TachoSync hanno una validità di 12 mesi. Ogni nuovo acquisto proroga la data di scadenza di altri 12 mesi, garantendo che i crediti rimangano disponibili fintanto che l'utente rimane attivo.",
      "main title": "Come funzionano i crediti",
      "middle content": {
        "description": "L'utilizzo dei crediti della tua flotta riflette esattamente il numero di veicoli attivi, in base al numero di telaio (VIN) univoco. I dispositivi possono essere sostituiti, spostati da un veicolo all'altro o riassegnati tra società controllate senza consumare crediti aggiuntivi, purché l'identità del veicolo sia già stata stabilita.",
        "header": "I crediti sono riservati per ogni veicolo attivo, non per ogni dispositivo.",
        "read more on wiki": "Maggiori informazioni su Wiki"
      },
      "top content": {
        "active vehicle": "Veicolo attivo",
        "device can change freely": "Il dispositivo può essere sostituito liberamente",
        "equals one credit": "= 1 credito",
        "identified by IMEI": "Identificato tramite IMEI",
        "identified by VIN": "Identificato tramite VIN",
        "tracking device": "Dispositivo di localizzazione"
      }
    },
    "Inactive": "Inattivo",
    "last 12 months": "Ultimi 12 mesi",
    "news": "Notizie",
    "no history to show": "Non ci sono dati storici da visualizzare",
    "no news": "Nessuna notizia da mostrare",
    "no results": "Nessun risultato",
    "NoDownloads": "Nessun download",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "Puntuale",
    "Overdue": "Scaduto",
    "Remaining": "Rimanente",
    "Reserved": "Riservato",
    "response error": "Si è verificato un errore. Prova ad aggiornare la pagina",
    "timeline": "Cronologia",
    "tooltip": {
      "click to expand": "Clicca per espandere",
      "connected card expire soon": "La carta scadrà a breve: {{expirationDate}}",
      "disconnected card": "La carta aziendale è disconnessa. Ultima visualizzazione: {{lastSeen}}.",
      "disconnected card expire soon": "La carta aziendale è disconnessa. Ultima visualizzazione: {{lastSeen}}. \n La carta scadrà a breve: {{expirationDate}}.",
      "expired card": "La carta è scaduta il {{expirationDate}}. Sostituisci la carta aziendale con una valida.",
      "offline card": "La carta aziendale è offline. Ultima visualizzazione: {{lastSeen}}.",
      "take me there": "Portami lì"
    },
    "Upcoming charge": "Addebito imminente",
    "vehicle data": "Dati dei veicoli",
    "vehicle downloads": "Download relativi ai veicoli",
    "view history": "Visualizza cronologia"
  },
  "Date picker": {
    "disableFuture": "Data disabilitata",
    "disablePast": "Data disabilitata",
    "invalid date format": "Formato data non valido",
    "invalidDate": "Data non valida",
    "maxDate": "Data errata",
    "minDate": "Data errata",
    "shouldDisableDate": "Data disabilitata"
  },
  "Details": {
    "activities": "Attività",
    "add new email recipient": {
      "choose a file format": "Scegli un formato di file",
      "enter email": "Inserisci l'indirizzo e-mail",
      "title": "Aggiungi nuovo destinatario"
    },
    "api company id": "ID azienda API",
    "autoAssignGlobalScheduleToDriver": "Assegna il programma globale ai nuovi autisti",
    "autoAssignGlobalScheduleToVehicle": "Assegna il programma globale ai nuovi veicoli",
    "automaticDriverRegistrationEnabled": "Registrazione automatica dei nuovi conducenti",
    "card holder": "Nome del titolare della carta",
    "client code": "Codice cliente",
    "close details": "Chiudi dettagli",
    "company": "Azienda",
    "company cards": "Carte aziendali",
    "company cards limit reached": "Hai raggiunto il numero massimo di tessere aziendali per questa azienda, {{currCount}}/{{maxCount}}.",
    "company settings": "Impostazioni aziendali",
    "Completed": "Completato",
    "connection settings": "Impostazioni di connessione",
    "creator": "Creatore",
    "credits": "Crediti",
    "credits overdraft tooltip": "La logica di prenotazione del credito mensile è stata aggiornata per consentire un saldo negativo all'interno dell'account. Ciò contribuirà a rendere più agevole il passaggio da Web Tacho senza esercitare pressioni sugli acquisti immediati di credito.",
    "current status": "Stato attuale",
    "Daily": "Giornaliero",
    "data types": "Tipi di dati",
    "deactivated": "Disattivato",
    "deactivated vehicle banner": {
      "description": "Questo veicolo non accumulerà nuovi crediti e i file del veicolo non potranno essere scaricati fino a quando non sarà attivato.",
      "link": "Attiva veicolo",
      "title": "Il veicolo è disattivato"
    },
    "detailed speed": "Velocità dettagliata",
    "details": "Dettagli",
    "device imei": "IMEI",
    "device status": "Stato del dispositivo",
    "download status": "Stato del download",
    "download time": "Tempo di download",
    "DownloadPending": "Download in coda",
    "driver": "Autista",
    "driver id": "ID conducente",
    "driver status": "Stato del conducente",
    "drivers": "Autisti",
    "edit": "Modifica",
    "edit user": "Modifica {{userEmail}}",
    "email limit reached": "Hai raggiunto il numero massimo di e-mail consentite per questa azienda.",
    "email transfer": "Trasferimento via e-mail",
    "email transfer info tooltip": "La funzione di trasferimento via e-mail consente di ricevere i dati scaricati dal tachigrafo tramite e-mail. Una volta completato un ciclo, il sistema inoltrerà automaticamente l'e-mail ai destinatari configurati. Ogni azienda può aggiungere fino a {{maxCount}} destinatari e-mail.",
    "endpointUrl": "URL dell'endpoint",
    "events and faults": "Eventi e guasti",
    "Every  days": "Ogni {{count}} giorni",
    "Every month": "Ogni mese",
    "EveryDays": "Ogni {{count}} giorni",
    "Feature not available in BETA version": "Funzionalità non disponibile nella versione BETA",
    "file format": "Formato file",
    "file sync": "Sincronizzazione dei file",
    "general": "Generale",
    "host": "Host",
    "imei": "IMEI",
    "included": "Incluso",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Ultima attività",
    "last download attempt": "Ultimo tentativo di download",
    "last successful download": "Ultimo download riuscito",
    "Never": "Mai",
    "next download": "Scarica il prossimo file",
    "next download attempt": "Prossimo tentativo di download",
    "Next download attempt in  day": "Prossimo tentativo di download tra {{count}} giorni",
    "Next download attempt in  days": "Prossimo tentativo di download tra {{count}} giorni",
    "no company cards": "Nessuna carta aziendale aggiunta.",
    "no driver schedule": "Al conducente non sono stati assegnati orari.",
    "no recipients added": "Nessun destinatario aggiunto",
    "no vehicle schedule": "Al veicolo non sono stati applicati programmi.",
    "not included": "Non incluso",
    "on next connection": "Alla prossima connessione",
    "open files": "Apri file",
    "open files disabled tooltip": "Questo oggetto non ha file disponibili.",
    "other": "Altro",
    "overview": "Panoramica",
    "parent company": "Società madre",
    "password": "Password",
    "port": "Port",
    "Quick schedule was completed": "Il programma rapido è stato completato",
    "remotePath": "Percorso della directory remota",
    "remove": "Rimuovi",
    "remove email recipient": {
      "description": "Sei sicuro di voler rimuovere questo destinatario dell'e-mail? Questa azione non può essere annullata.",
      "title": "Rimuovere {{userEmail}}?"
    },
    "remove schedule": "Rimuovi programma",
    "reserved": "Riservato",
    "schedule details": "Dettagli dell'orario",
    "schedule history": "Cronologia degli orari",
    "schedule start time": "Ora di inizio della pianificazione",
    "schedules": "Orari",
    "show less": "Mostra meno",
    "show more": "Mostra altro",
    "show older": "Mostra i più vecchi",
    "status": "Stato",
    "sub companies": "Società controllate",
    "technical data": "Dati tecnici",
    "Upon device connection": "Connessione sul dispositivo",
    "username": "Nome utente",
    "users": "Utenti",
    "vehicles": "Veicoli",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "In attesa della connessione del dispositivo",
    "WaitingForScheduleStartTime": "In attesa dell'ora di inizio prevista"
  },
  "Dialog": {
    "account id": "ID account",
    "account id cannot contain more than": "L'ID account non può contenere più di {{maxNumber}} caratteri",
    "activate vehicles": {
      "description": "Una volta attivati, i veicoli potranno accumulare crediti in base a una connessione mensile unica. Sei sicuro di voler attivare il seguente numero di veicoli?",
      "title": "Attivare i veicoli?"
    },
    "add": "Aggiungi",
    "add company card": "Aggiungi nuova scheda aziendale",
    "add driver": "Aggiungi autista",
    "add integration": "Aggiungi integrazione",
    "add new integration": {
      "description": "Scegli il tipo di integrazione che desideri aggiungere e configura i dettagli nel passaggio successivo.",
      "title": "Aggiungi nuova integrazione"
    },
    "add vehicle": "Aggiungi veicolo",
    "add vehicle description": "Aggiungi un veicolo inserendo manualmente tutti i dati di immatricolazione.",
    "add vehicle imei in use accessible": {
      "description": "Questo IMEI è già associato a un altro veicolo. Riassegnarlo disconnetterà quel veicolo dal download dei file. Sei sicuro di voler continuare?",
      "title": "IMEI già in uso",
      "vehicle imei": "Veicolo con IMEI \"{{imeiValue}}\":"
    },
    "all resource": "Tutte le {{resource}}",
    "api key": "Chiave API",
    "api key placeholder": "Inserisci la chiave API",
    "api key cannot contain more than": "La chiave API non può contenere più di {{maxNumber}} caratteri",
    "api key edit": {
      "dialog title": "Modifica chiave API \"{{keyName}}\"",
      "success banner": "Chiave API modificata con successo."
    },
    "api key name": "Nome chiave",
    "api key name required": "Il nome della chiave non può essere vuoto",
    "api key name too long": "Il nome della chiave non può contenere più di {{maxNumber}} caratteri",
    "api management": {
      "description": "Crea la tua chiave API per gestire in modo sicuro l'accesso API al nostro sistema, consentendo una perfetta integrazione con il tuo software e i tuoi flussi di lavoro. La documentazione dell'API di TachoSync è disponibile ",
      "generated api key": "Chiave API generata",
      "success banner": "La chiave API è stata creata con successo. Assicurati di salvare le informazioni riportate di seguito, poiché non potrai visualizzarle nuovamente."
    },
    "cancel invitation": "Annulla invito",
    "cancel invitation description": "Sei sicuro di voler annullare l'invito per {{userEmail}}?",
    "card holder name": "Nome del titolare della carta",
    "card holder name not valid": "Il nome del titolare della carta non può contenere più di {{maxNumber}} caratteri",
    "card holder name should not be empty": "Il nome del titolare della carta non deve essere vuoto",
    "card holder name too short": "Il nome del titolare della carta deve contenere almeno {{minNumber}} caratteri",
    "card id not valid": "L'ID della carta non può contenere più di {{maxNumber}} caratteri",
    "card id should contain only digits, letters and hyphens": "L'ID della carta deve contenere solo cifre (0–9), lettere A–F e trattini (-).",
    "card id should contain only numbers": "L'ID della carta deve contenere solo numeri",
    "card id should not be empty": "L'ID della scheda non deve essere vuoto",
    "card id too short": "L'ID della carta deve contenere almeno {{minNumber}} caratteri",
    "card name": "Nome della carta",
    "card name not valid": "Il nome della carta non può contenere più di {{maxNumber}} caratteri",
    "card name should not be empty": "Il nome della carta non deve essere vuoto",
    "card name too short": "Il nome della carta deve contenere almeno {{minNumber}} caratteri",
    "choose period": "Scegli il periodo",
    "client company": "Azienda cliente",
    "company": "Azienda",
    "company card id": "ID carta aziendale",
    "company name": "Nome dell'azienda",
    "company name in tachoSync": "Nome dell'azienda in TachoSync",
    "company name placeholder": "Es.: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Consentire lo scoperto di conto",
      "auto add new drivers": "Registrazione automatica dei nuovi conducenti",
      "auto add new drivers tooltip": "Non appena viene riconosciuto un nuovo ID conducente, TachoSync lo aggiunge automaticamente alla tabella dei conducenti.",
      "auto assign global schedule to drivers": "Assegnazione automatica del programma globale ai nuovi autisti",
      "auto assign global schedule to drivers tooltip": "Applica automaticamente una pianificazione globale dei download ai conducenti appena registrati, garantendo il download dei dati senza intervento manuale.",
      "auto assign global schedule to vehicles": "Assegnazione automatica del programma globale ai nuovi veicoli",
      "auto assign global schedule to vehicles tooltip": "Applica automaticamente una pianificazione globale dei download ai veicoli appena registrati, garantendo il download dei dati senza intervento manuale.",
      "auto download driver data": "Download automatico dei dati del conducente alla prima connessione",
      "auto download driver data tooltip": "Scarica automaticamente i dati della carta del conducente al primo collegamento. Ciò garantisce l'acquisizione della cronologia completa dei nuovi conducenti prima di impostare i turni.",
      "auto update vehicle registration number": "Aggiornamento automatico del numero di immatricolazione del veicolo (VRN)",
      "auto update vehicle registration number tooltip": "Se abilitata, la VRN inserita al momento della creazione del veicolo viene sovrascritta con il valore letto dai dati del tachigrafo dopo il primo download riuscito.",
      "automatic initial vehicle download": "Download automatico dei dati del veicolo alla prima connessione",
      "automatic initial vehicle download tooltip": "Scarica automaticamente i dati del veicolo al primo collegamento. Ciò garantisce l'acquisizione della cronologia completa dei nuovi veicoli prima di impostare i programmi.",
      "title": "Impostazioni aziendali"
    },
    "confirm add schedule": "Aggiungi programma?",
    "confirm deactivate api key": {
      "description": "Sei sicuro di voler disattivare la chiave API \"{{apiKeyName}}\"?",
      "title": "Disattivare la chiave API?"
    },
    "confirm deactivate integration": {
      "description": "Sei sicuro di voler disattivare l'integrazione \"{{integrationName}}\"?",
      "title": "Disattivare l'integrazione?"
    },
    "confirm delete analysis providers": "Sei sicuro di voler eliminare il seguente numero di fornitori di analisi? Questa azione non può essere annullata.",
    "confirm delete api credentials": "Sei sicuro di voler eliminare le credenziali API selezionate? Questa azione non può essere annullata e qualsiasi chiamata API effettuata utilizzando queste credenziali verrà immediatamente rifiutata.",
    "confirm delete companies": "Sei sicuro di voler eliminare l'azienda selezionata? Questa operazione non può essere annullata.",
    "confirm delete drivers": "Sei sicuro di voler eliminare il seguente numero di conducenti?",
    "confirm delete integrations": "Sei sicuro di voler eliminare il seguente numero di integrazioni? Questa azione non può essere annullata.",
    "confirm delete users": "Sei sicuro di voler eliminare il seguente numero di utenti? Questa operazione non può essere annullata.",
    "confirm delete vehicles": "Sei sicuro di voler eliminare il seguente numero di veicoli?",
    "confirm empty imei": {
      "description": "Non hai compilato il campo IMEI. I veicoli privi di IMEI non possono connettersi a TachoSync e non sono in grado di scaricare file.\nSei sicuro di voler continuare?",
      "title": "Nessun IMEI aggiunto"
    },
    "convey integration": {
      "add": {
        "description": "Configura la tua connessione Convey",
        "title": "Aggiungi integrazione Convey"
      },
      "edit": {
        "description": "Configura la tua connessione Convey",
        "title": "Modifica l'integrazione con Convey"
      },
      "provider settings description": "Assicurati di utilizzare le credenziali fornite da Convey.",
      "provider settings title": "Impostazioni del fornitore"
    },
    "create": "Crea",
    "create company": "Crea azienda",
    "create company main description": "Scegli se creare una nuova società controllata all'interno di questa gerarchia oppure creare un nuovo cliente utilizzando un codice LZ cliente.",
    "create new hierarchy": "Crea nuova gerarchia",
    "create news": "Crea notizia",
    "create news description": "Descrivi brevemente il contenuto del modal.",
    "create quick schedule": "Crea un programma veloce",
    "create schedule": "Crea programma",
    "create schedule description": "Imposta il download automatico dei file selezionando data, ora e frequenza. Il sistema gestirà i download per te, garantendo la conformità e l'accuratezza dei dati senza alcun intervento manuale. L'ora di inizio della pianificazione non può essere impostata in un momento passato.",
    "credits history": {
      "description": "Tieni traccia del tuo saldo crediti attuale e visualizza lo storico dei tuoi dati.",
      "description generate report": "tieni traccia del tuo saldo crediti attuale, visualizza lo storico dei tuoi dati e genera un report in formato \".csv\" di tutti i crediti consumati negli ultimi 12 mesi.",
      "generate report description": "Scegli un periodo qualsiasi negli ultimi 12 mesi e genera un report dei crediti consumati.",
      "generate report title": "Genera report",
      "title": "Cronologia dei crediti"
    },
    "custom period": "Periodo personalizzato",
    "date display format": "Formato di visualizzazione della data",
    "date range": "Intervallo di date",
    "deactivate vehicle": "Disattiva questo veicolo",
    "deactivate vehicle description": "I veicoli disattivati non accumuleranno nuovi crediti e non po",
    "deactivate vehicles": {
      "description": "I veicoli disattivati non accumuleranno nuovi crediti e non potranno scaricare dati.",
      "title": "Disattivare i veicoli?"
    },
    "delete": "Elimina",
    "delete analysis providers": "Eliminare i fornitori di analisi?",
    "delete api credentials": "Eliminare le credenziali API?",
    "delete companies": "Eliminare aziende?",
    "delete companies warning": "L'azione di eliminazione delle aziende comporterà la cancellazione di tutte le risorse appartenenti a tali aziende.",
    "delete drivers": "Eliminare i conducenti?",
    "delete integrations": "Eliminare le integrazioni?",
    "delete news": "Eliminare la notizia?",
    "delete news description": "Sei sicuro di voler eliminare le notizie selezionate?",
    "delete unpublished release notes": "Eliminare le note di rilascio non pubblicate?",
    "delete unpublished release notes description": "Sei sicuro di voler eliminare le note di rilascio non pubblicate?",
    "delete users": "Eliminare utenti?",
    "delete vehicles": "Eliminare veicoli?",
    "description": "Descrizione (facoltativa)",
    "description not valid": "La descrizione non può contenere più di {{maxNumber}} caratteri",
    "description required": "Descrizione",
    "description should not be empty": "La descrizione non puo' essere vuota",
    "device imei": "IMEI del dispositivo",
    "dialog description": {
      "create company description": "Il numero massimo di livelli consentiti in un albero aziendale è {{maxNumber}}.",
      "create new hierarchy description": "Il numero massimo consentito di livelli aziendali in un albero aziendale è {{maxNumber}}. Scegli se creare una nuova società figlia all'interno di questa gerarchia o creare un nuovo cliente utilizzando un codice LZ cliente."
    },
    "download activities": "Attività di download",
    "download blocked message": "Download bloccato: contatta il tuo provider per risolvere il problema.",
    "download data types": "Tipi di dati scaricabili",
    "download drivers files": "Scarica i file dei driver",
    "download history dialog title": "Cronologia di {{vehicleNumber}}",
    "download monitoring dialog tooltip": "Tutti i dati in questa schermata vengono aggiornati automaticamente ogni <strong>10 secondi</strong>.\nLo stato del dispositivo riflette l'ultima connessione, non lo stato attuale del veicolo.",
    "download only selection": "Verranno scaricati solo i file selezionati.",
    "download sample file message": "Scarica un <1>modello</1> CSV di esempio per vedere un esempio del formato richiesto.",
    "download status banners": {
      "CompanyCardExpired": "La tessera aziendale è scaduta. Si prega di inserire una tessera aziendale valida.",
      "InsufficientCredits": "Crediti insufficienti. Aggiungi crediti per scaricare i file.",
      "NoCompanyCards": "La carta aziendale deve essere online per avviare il download. Nessuna carta disponibile al momento.",
      "NoSchedulesApplied": "A questo veicolo non sono stati applicati orari.",
      "VehicleDeactivated": "Questo veicolo è disattivato e non può avviare il processo di download."
    },
    "download status dialog title": "Monitoraggio dei download di {{vehicleNumber}}",
    "download vehicles files": "Scarica i file relativi ai veicoli",
    "driver file destination": "Destinazione dei file dei conducenti",
    "driver file destination tooltip": "Scegliere se i file dei conducenti devono essere salvati nella cartella del veicolo da cui sono stati scaricati oppure in cartelle dedicate ai conducenti in base all'ID conducente.",
    "driver folder": "Cartella autista",
    "driver id": "ID conducente",
    "driver id not valid": "L'ID autista deve contenere {{maxNumber}} caratteri alfanumerici",
    "driver id placeholder": "Es.: 360896050032309",
    "driver id should not be empty": "L'ID dell'autista non puo' essere vuoto",
    "driver name": "Nome del conducente",
    "drivers folder naming": "Denominazione delle cartelle dei conducenti",
    "edit company": "Modifica azienda \"{{name}}\"",
    "edit driver": "Modifica autista \"{{name}}\"",
    "edit news": "Modifica notizia",
    "edit release notes tooltip": "Queste notizie sono state create come note di rilascio e non possono essere modificate.",
    "edit user": "Modifica utente",
    "edit vehicle": "Modifica veicolo \"{{name}}\"",
    "edit vehicle imei in use accessible": {
      "description": "Questo IMEI è già assegnato a un altro veicolo. È possibile scegliere di scambiare gli IMEI tra i due veicoli oppure sovrascrivere l'IMEI.",
      "title": "IMEI già in uso"
    },
    "email": "E-mail",
    "endpointUrl": "URL dell'endpoint",
    "endpoint url": "URL dell'endpoint",
    "endpoint url not valid": "L'URL dell'endpoint non è valido",
    "endpoint url placeholder": "Inserisci l'URL",
    "enter": "Inserisci",
    "enter company card id": "Inserisci l'ID della Company Card che trovi all'interno dell'applicazione Company Card Authenticator.",
    "enter here": "inserisci",
    "enter name": "Inserisci nome",
    "enter password": "Inserisci la password",
    "enter username": "Inserisci nome utente",
    "expiration date optional": "Data di scadenza (facoltativa)",
    "export drivers": {
      "description": "Esporta tutti i conducenti dell'azienda selezionata nei file .csv richiesti.",
      "include drivers from all companies": "Includere gli autisti di tutte le aziende",
      "title": "Esportazione autisti"
    },
    "export vehicles": {
      "description": "Esporta tutti i veicoli dell'azienda selezionata nei file .csv richiesti.",
      "include vehicles from all companies": "Includere i veicoli di tutte le aziende",
      "title": "Esportazione veicoli"
    },
    "feature switches": {
      "feature switches": "Opzioni",
      "toggle integrations page": "Abilita pagina integrazioni"
    },
    "field cannot be changed": "Questo campo non può essere modificato",
    "field cannot be empty": "{{fieldName}} non può essere vuoto",
    "field length not valid": "Questo campo non può contenere più di {{maxNumber}} caratteri",
    "file format": "Formato file",
    "filtered resource": "Filtrato {{risorsa}}",
    "filtered drivers": "Autisti filtrati",
    "filtered vehicles": "Veicoli filtrati",
    "from": "Da",
    "future dates": {
      "1 day": "tra 1 giorno",
      "1 minute": "tra 1 minuto",
      "1 month": "tra 1 mese",
      "1 week": "tra 1 settimana",
      "1 year": "tra 1 anno",
      "hours and minutes": "tra {{hourCount}}h {{minutesCount}}m",
      "less than a minute": "in <1 minuto",
      "multiple days": "tra {{daysCount}} giorni",
      "multiple minutes": "tra {{minutesCount}} minuti",
      "multiple months": "tra {{monthsCount}} mesi",
      "multiple weeks": "tra {{weeksCount}} settimane",
      "multiple years": "tra {{yearsCount}} anni"
    },
    "generate api key": {
      "title": "Genera chiave API"
    },
    "host": "Host",
    "host cannot contain more than": "L'host non può contenere più di {{maxNumber}} caratteri",
    "imei": "IMEI",
    "imei not valid": "L'IMEI deve contenere {{maxNumber}} caratteri numerici",
    "imei placeholder": "Es.: 360896050032309",
    "imei should not be empty": "L'IMEI non puo' essere vuoto",
    "import drivers": "Importa autisti",
    "import drivers description": "Aggiungi i conducenti al tuo elenco importandoli da un file.",
    "import vehicles": "Importa veicoli",
    "import vehicles description": "Aggiungi veicoli al tuo elenco importandoli da un file.",
    "integration name": "Nome dell'integrazione",
    "integration type": "Tipo di integrazione",
    "integrations": {
      "deactivate integration": {
        "title": "Disattiva questa integrazione",
        "tooltip": "Disattiva temporaneamente l'integrazione. Puoi riattivarla deselezionando questa opzione."
      },
      "deactivate api key": "Disattiva chiave API",
      "deactivate sftp": "Disattiva SFTP",
      "deactivate integration tooltip": "Disattiva temporaneamente l'integrazione. Puoi riattivarla deselezionando questa opzione.",
      "disable integration": {
        "description": "Sei sicuro di voler disabilitare l'integrazione \"{{integrationName}}\"?",
        "title": "Disattivare l'integrazione?"
      },
      "driver files info banner": "Si prega di notare che i file dei conducenti scaricati prima del {{formattedDate}} saranno inseriti nella cartella del veicolo più recente guidato dal conducente. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Assicurati di aver inserito correttamente nome utente e password.\nL'integrazione verrà salvata con lo stato \"Non riuscita\" finché non verranno inserite le credenziali corrette.",
          "title": "Credenziali errate."
        },
        "FolderCreationFailed": {
          "description": "TachoSync è connesso al server, ma non dispone dell'autorizzazione per creare cartelle o caricare file nel percorso di destinazione.\nL'integrazione verrà salvata con lo stato \"Non riuscita\" fino a quando il problema non sarà risolto e non si riproverà a connettersi.",
          "title": "Accesso in scrittura mancante."
        },
        "HostUnreachable": {
          "description": "Assicurati che l'indirizzo e la porta del server siano corretti e che il server sia online.\nL'integrazione verrà salvata con lo stato \"Fallita\" fino a quando il problema non sarà risolto e non riproverai a connetterti.",
          "title": "Host non raggiungibile."
        },
        "PathNotFound": {
          "description": "Impossibile individuare la directory specificata sul server. Verificare che il percorso sia corretto.\nL'integrazione verrà salvata con lo stato \"Fallita\" fino a quando non verrà indicato il percorso corretto.",
          "title": "Percorso non trovato."
        },
        "PermissionDenied": {
          "description": "Assicurati che TachoSync disponga delle autorizzazioni necessarie per accedere a questo percorso.\nL'integrazione verrà salvata con lo stato \"Non riuscita\" finché le autorizzazioni non saranno aggiornate e non riproverai a connetterti.",
          "title": "Accesso al percorso negato."
        },
        "Unknown": {
          "description": "Si è verificato un problema imprevisto durante il tentativo di connessione al server SFTP. Controlla i dettagli e le impostazioni del tuo server.\nL'integrazione verrà salvata con lo stato \"Non riuscita\" fino a quando il problema non sarà risolto e non riproverai a connetterti.",
          "title": "Si è verificato un errore imprevisto."
        }
      },
      "include files from all sub companies": "Includi i file di tutte le società controllate",
      "include files tooltip": "Se selezionata, questa integrazione recupererà anche i file da tutte le società controllate presenti nel tuo account",
      "include historical files": "Includi file storici",
      "include historical files tooltip": "Se selezionato, verranno recuperati anche i file scaricati prima della creazione di questa integrazione.",
      "select driver files destination": "Seleziona la destinazione dei file del conducente"
    },
    "introduce name": "Inserisci nome",
    "invite user": "Invita utente",
    "invite user description": "Una volta inviato l'invito, l'utente riceverà un'\ne-mail con un link per la creazione dell'account. Il link sarà valido per 7 giorni.",
    "invite user sent": "Invito utente inviato con successo.",
    "loading": "Caricamento in corso...",
    "make release notes": "Crea note di rilascio",
    "make release notes info": "Se questo campo è selezionato, la notizia verrà pubblicata nelle Note di rilascio e il titolo verrà modificato in Note di rilascio.",
    "max download files": "Numero massimo di file consentiti per ogni operazione di download: {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Sei sicuro?",
        "description": "Stai per trasferire \"{{sourceCompany}}\" a \"{{targetCompany}}\". Questa operazione è irreversibile, sei sicuro di voler continuare?"
      },
      "description": "Selezionare un'azienda di origine e un'azienda di destinazione a cui trasferirla. L'azienda di origine e le relative risorse verranno inserite nell'azienda di destinazione selezionata. Questa operazione è irreversibile.",
      "error dialog": {
        "description": "Il numero massimo consentito di livelli aziendali è 4. Spostando qui l'azienda selezionata si supererebbe tale limite.",
        "title": "Impossibile trasferire l'azienda"
      },
      "info banner": "L'azienda di origine manterrà tutti i propri veicoli, autisti, file, aziende, utenti, integrazioni e pianificazioni personalizzate. Se a livello dell'azienda principale è abilitata una pianificazione globale, questa verrà ereditata dopo il trasferimento. In caso contrario, le pianificazioni esistenti verranno mantenute così come sono.",
      "source company": "Azienda di origine",
      "sftp warning": "L'azienda selezionata dispone di un server SFTP attivo e configurato. La connessione SFTP verrà interrotta durante il trasferimento dell'azienda. Una volta completato il trasferimento, verrà creato un nuovo percorso SFTP e la connessione verrà ripristinata.",
      "target company": "Azienda di destinazione",
      "title": "Trasferimento dell'azienda"
    },
    "move vehicles": "Sposta veicoli",
    "move vehicles info": "Nota: i file relativi ai veicoli rimarranno nell'azienda attuale. La cronologia dei download verrà cancellata e i download pianificati verranno rimossi.",
    "name": "Nome",
    "name not valid": "Il nome non può contenere più di {{maxNumber}} caratteri",
    "name should not be empty": "il nome non puo' essere vuoto",
    "name too short": "Il nome deve contenere almeno {{minNumber}} caratteri",
    "optional": "opzionale",
    "overwrite imei checkbox": {
      "description": "Questa opzione rimuoverà l'IMEI da {{vehicleNumber}}.",
      "title": "Sovrascrivere IMEI."
    },
    "parent company": "Società madre",
    "password": "Password",
    "password cannot contain more than": "La password non può contenere più di {{maxNumber}} caratteri",
    "past dates": {
      "1 month ago": "1 mese fa",
      "1 week ago": "1 settimana fa",
      "1 year ago": "1 anno fa",
      "multiple months ago": "{{monthCount}} mesi fa",
      "multiple weeks ago": "{{weekCount}} settimane fa",
      "multiple years ago": "{{yearCount}} anni fa",
      "today": "Oggi",
      "yesterday": "Ieri"
    },
    "port": "Port",
    "port must be between": "Il valore di Port deve essere compreso tra {{minNumber}} e {{maxNumber}}",
    "previous month": "Mese precedente",
    "provider": "Fornitore",
    "publish news": "Pubblicare notizie?",
    "publish news description": "Questa notizia è pronta per la pubblicazione. Sei sicuro di voler continuare? Questa azione non può essere annullata.",
    "publish release notes": "Pubblicare le note di rilascio?",
    "publish release notes description": "Le note di rilascio sono pronte per la pubblicazione. Sei sicuro di voler continuare? Questa azione non può essere annullata.",
    "release notes": "Note di rilascio",
    "remote directory path cannot contain more than": "Il percorso della directory remota non può contenere più di {{maxNumber}} caratteri",
    "remote directory path optional": "Percorso della directory remota (facoltativo)",
    "remove": "Rimuovi",
    "remove schedules": "Rimuovi programmi",
    "remove schedules confirmation description": {
      "drivers multiple": "Sei sicuro di voler rimuovere i programmi {{resourceValue}} dai conducenti selezionati?",
      "drivers single": "Sei sicuro di voler rimuovere {{resourceValue}} dai conducenti selezionati?",
      "vehicles multiple": "Sei sicuro di voler rimuovere i programmi {{resourceValue}} dai veicoli selezionati?",
      "vehicles single": "Sei sicuro di voler rimuovere {{resourceValue}} dai veicoli selezionati?"
    },
    "remove schedules description": {
      "drivers": "Scegli uno o più programmi che desideri rimuovere dai conducenti selezionati.",
      "vehicles": "Scegli uno o più programmi che desideri rimuovere dai veicoli selezionati."
    },
    "resend invitation": "Invia nuovamente l'invito",
    "resend invitation description": "Sei sicuro di voler inviare nuovamente l'invito a {{userEmail}}?",
    "role": "Ruolo",
    "schedule apply to all": {
      "drivers": "Il programma selezionato verrà applicato a tutti i conducenti dell’azienda selezionata.",
      "vehicles": "Il programma selezionato verrà applicato a tutti i veicoli dell’azienda selezionata."
    },
    "schedule apply to filtered": {
      "drivers": "Il programma selezionato verrà applicato agli autisti filtrati utilizzando uno o più filtri disponibili.",
      "vehicles": "Il programma selezionato verrà applicato ai veicoli filtrati utilizzando uno o più filtri disponibili."
    },
    "schedule apply to selected": {
      "drivers": "Il programma selezionato verrà applicato a tutti i conducenti selezionati tramite la casella di spunta.",
      "vehicles": "Il programma selezionato verrà applicato a tutti i veicoli selezionati tramite la casella di controllo."
    },
    "schedule time tooltip description": "Se l'ora selezionata è passata, il sistema la modificherà automaticamente all'ora futura più vicina disponibile.",
    "security settings": "Impostazioni di sicurezza",
    "security settings description": "Trova le opzioni che ti consentono di controllare come viene protetto il tuo account.",
    "select": "Seleziona",
    "select a company": "Seleziona un'azienda",
    "select file format example": "Seleziona il formato (ad es. .DDD)",
    "select format": "Seleziona formato",
    "select image": "Seleziona immagine",
    "select image description": "Seleziona l'immagine che desideri utilizzare cliccandoci sopra e premendo il pulsante Salva.",
    "select schedules": "Seleziona gli orari",
    "selected resource": "Risorsa selezionata {{resource}}",
    "selected drivers": "Autisti selezionati",
    "selected vehicles": "Veicoli selezionati",
    "selected role info message": "<3>Clicca qui</3> per visualizzare la tabella dettagliata delle autorizzazioni.",
    "selected role info message title": "Il ruolo determinerà le autorizzazioni degli utenti in TachoSync.",
    "sftp integration": {
      "description": "Configura la tua connessione SFTP e definisci la struttura dei file del tachigrafo.",
      "edit title": "Modifica integrazione SFTP",
      "sftp name": "Nome SFTP",
      "title": "Integrazione SFTP"
    },
    "sftp password": "Password SFTP",
    "sftp server hostname or ip": "Nome host o IP del server SFTP",
    "sftp server port number": "Numero di porta del server SFTP",
    "sftp server settings": "Impostazioni del server SFTP",
    "sftp username": "Nome utente SFTP",
    "Teltonika code": "Codice Teltonika",
    "Teltonika code invalid characters": "Il codice Teltonika deve essere composto da {{minCount}}–{{maxCount}} caratteri e può includere lettere, numeri e punti.",
    "Teltonika code placeholder": "Il codice Teltonika deve contenere {{minCount}}-{{maxCount}} caratteri",
    "Teltonika company name": "Nome dell'azienda",
    "time": "Ora",
    "time zone": "Fuso orario",
    "title": "Titolo",
    "title not valid": "Il titolo non può contenere più di {{maxNumber}} caratteri",
    "title should not be empty": "Il titolo non deve essere vuoto",
    "title too short": "Il titolo deve contenere almeno {{minNumber}} caratteri",
    "to": "A",
    "toggle children global schedule linking": "Collegato alla società madre Calendario globale",
    "toggle children global schedule linking tooltip": "L'azienda principale ha abilitato l'ereditarietà del programma globale. Per modificare il programma globale dell'azienda selezionata, disabilitare questa opzione. Si noti che ciò disconnetterà il programma globale dall'azienda principale.",
    "toggle global schedule linking": "Applica il programma globale a tutte le società controllate",
    "toggle global schedule linking tooltip": "Abilitando questa opzione, la pianificazione globale viene applicata a tutte le società controllate. Le società controllate possono disabilitare questa opzione per personalizzare la propria pianificazione globale.",
    "toggle global schedule warning banner": "È possibile che alcune società controllate stiano già utilizzando un programma globale diverso. Questa opzione non avrà alcun effetto su di esse, a meno che non la selezionino nelle impostazioni del loro programma globale.",
    "unpublished release notes": "Sono presenti note di rilascio non pubblicate",
    "upload folder blank for root": "carica cartella (lascia vuoto per la directory)",
    "username": "Nome utente",
    "username cannot contain more than": "Il nome utente non può contenere più di {{maxNumber}} caratteri",
    "vdo integration": {
      "add": {
        "description": "Configura la connessione della tua flotta VDO.",
        "title": "Aggiungi l’integrazione della flotta VDO"
      },
      "edit": {
        "description": "Configura la connessione della tua flotta VDO.",
        "title": "Modifica dell’integrazione della flotta VDO"
      },
      "provider settings description": "Assicurati di utilizzare le credenziali fornite da VDO Fleet.",
      "provider settings title": "Impostazioni del fornitore"
    },
    "vehicle folder": "Cartella veicolo",
    "vehicle imei in use inaccessible": {
      "description": "Questo IMEI è già assegnato a un'azienda al di fuori del vostro gruppo aziendale. Se un dispositivo con questo IMEI vi appartiene, contattate <supportLink>l'assistenza Teltonika</supportLink>.",
      "title": "IMEI utilizzato da un altro gruppo aziendale"
    },
    "vehicle name": "Nome del veicolo",
    "vehicle number": "Numero di immatricolazione del veicolo (VRN)",
    "vehicle registration number tooltip": "L'aggiornamento automatico è abilitato nelle impostazioni aziendali. Il VRN inserito qui verrà sovrascritto con il valore letto dai dati del tachigrafo dopo il primo download riuscito.",
    "vehicles folder naming": "Denominazione delle cartelle dei veicoli",
    "vrn": "VRN",
    "vrn should not be empty": "Il numero di immatricolazione del veicolo non deve essere vuoto",
    "welcome to beta version title": "Benvenuti al beta testing di TachoSync!"
  },
  "Download history": {
    "download successful": "Download completato con successo",
    "driver data": "Dati dei conducenti",
    "no history": "Qui verrà visualizzata la cronologia",
    "schedule": "Calendario"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "Errore di lettura del pacchetto APDU. Dispositivo disconnesso.",
    "Authenticating": "Autenticazione",
    "Authentication failure (02x10)": "Errore di autenticazione (02x10)",
    "Authentication failure after timeout (02x01)": "Errore di autenticazione dopo il timeout (02x01)",
    "Authentication failure after timeout (02x12)": "Errore di autenticazione dopo il timeout (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Errore di lettura della scheda. Reinserire la scheda aziendale, ricollegare il lettore di schede o riavviare il servizio.",
    "CheckingCredits": "Verifica dei crediti",
    "CompanyCardExpired": "Carta aziendale scaduta",
    "CompanyCardInUse": "Carta aziendale in uso",
    "Could not download any of files": "Impossibile scaricare alcun file",
    "CreditReserved": "Diritti riservati",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Download rifiutato: il VIN del dispositivo non corrisponde al VIN registrato per questo veicolo. Se il dispositivo è stato trasferito su un nuovo veicolo, creare una nuova scheda veicolo per continuare.",
    "DownloadingDriverData": "Download dei dati dei conducenti",
    "DownloadingDriverDataFailed": "Download dei dati del conducente non riuscito",
    "DownloadingVehicleData": "Download dei dati dei veicoli",
    "Driver info packet reading error. Device disconnected.": "Errore di lettura del pacchetto di informazioni sul conducente. Dispositivo disconnesso.",
    "Failed to download driver data": "Impossibile scaricare i dati del conducente",
    "Failed to receive APDU from card, timeout exceeded": "Impossibile ricevere l'APDU dalla scheda, tempo di attesa superato",
    "Failed to receive VUReady packet from device, timeout exceeded": "Impossibile ricevere il pacchetto VUReady dal dispositivo, timeout superato",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "Impossibile ricevere il pacchetto VUReady. Se il problema persiste, verificare la configurazione dei dispositivi telematici/tachigrafici.",
    "InsufficientCredits": "Crediti insufficienti",
    "Lost connection with device or card": "Connessione persa con il dispositivo o la scheda",
    "NoCompanyCards": "Nessuna carta aziendale",
    "NoDueSchedules": "Nessuna scadenza prevista",
    "NoSchedulesApplied": "Nessuna pianificazione applicata",
    "ProcessTerminated": "Processo terminato",
    "ReceivingDownloadList": "Ricezione dell'elenco dei download",
    "ReceivingDriverInfo": "Ricezione delle informazioni sui conducenti",
    "ReceivingDriversSchedules": "Ricezione degli orari dei conducenti",
    "ReceivingStatusState": "Stato di ricezione",
    "ReceivingVehicleSchedules": "Ricezione degli orari dei veicoli",
    "requirements": {
      "company card": "Carta aziendale",
      "credits available": "Crediti disponibili",
      "ignition": "Accensione",
      "ignition unavailable tooltip": "Sconosciuto - l'ultimo stato noto risale a più di 2 ore fa.",
      "imei": "IMEI",
      "schedule assigned": "Programma assegnato",
      "vehicle activated": "Attivazione tramite veicolo",
      "reason": {
        "CompanyCardExpired": "La carta aziendale è scaduta",
        "IgnitionNotReportedRecently": "Stato sconosciuto - lo stato dell'accensione non è stato segnalato di recente. Il download verrà comunque tentato, ma è meno probabile che vada a buon fine",
        "IgnitionOff": "L'accensione è spenta. Il download verrà comunque tentato, ma è meno probabile che vada a buon fine",
        "InsufficientCredits": "Non sono disponibili crediti",
        "NoCompanyCardOnline": "Al momento non è presente alcuna scheda aziendale online",
        "NoCompanyCards": "Al momento non è presente alcuna scheda aziendale online",
        "NoImeiAssigned": "Al veicolo non è stato assegnato alcun IMEI",
        "NoScheduleAssigned": "Il veicolo deve avere un programma assegnato",
        "VehicleDeactivated": "Per scaricare i dati è necessario attivare il veicolo"
      }
    },
    "schedules": {
      "assign schedules": "Assegnazione degli orari",
      "assign schedules dialog": {
        "description": "Scegli uno o più programmi che desideri assegnare.",
        "title": "Assegna gli orari a {{vehicleNumber}}"
      },
      "fail reason": {
        "download requirements not met": "requisiti di download non soddisfatti."
      },
      "no schedules assigned": "A questo veicolo non sono stati assegnati programmi",
      "on device connection": "alla connessione del dispositivo",
      "requirements not met": "Il programma non può essere eseguito finché non vengono soddisfatti tutti i requisiti."
    },
    "StageComplete": "Fase completata",
    "Stages": {
      "Authentication": "Autenticazione",
      "Downloading": "Download",
      "DownloadTrigger": "Trigger di download",
      "Initialization": "Inizializzazione"
    },
    "Status packet reading error. Device disconnected.": "Errore di lettura del pacchetto di stato. Dispositivo disconnesso.",
    "TerminatingConnectionToDevice": "Interruzione della connessione al dispositivo",
    "Timeout. Response from VU not received (02x01)": "Timeout. Risposta dalla VU non ricevuta (02x01)",
    "Too many KeepAlive packets received.": "Ricevuti troppi pacchetti KeepAlive.",
    "Unexpected error": "Errore imprevisto",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Perdita imprevista della connessione con il dispositivo. Una volta ripristinata la normale connettività del dispositivo, il download proseguirà.",
    "UploadingDriverFiles": "Caricamento dei file dei conducenti",
    "UploadingDriverFilesFailed": "Caricamento dei file dei conducenti non riuscito",
    "UploadingVehicleFiles": "Caricamento dei file dei veicoli",
    "UploadingVehicleFilesFailed": "Caricamento dei file dei veicoli non riuscito",
    "VehicleDeactivated": "Veicolo disattivato",
    "VuNotReady": "VU non pronto. Si riproverà tra 5 minuti",
    "VU ready packet reading error. Device disconnected.": "Errore di lettura del pacchetto in modalità VU. Dispositivo disconnesso.",
    "WaitingForDeviceConnection": "In attesa della connessione del dispositivo",
    "Wrong communication command": "Comando di comunicazione errato"
  },
  "Drivers": {
    "drivers page": "Autisti",
    "last activity": {
      "Available": "Disponibile",
      "BreakOrRest": "Pausa/Riposo",
      "Drive": "Guida",
      "NotAvailable": "Non disponibile",
      "Undefined": "N/A",
      "Unknown": "Sconosciuto",
      "Unknown4": "Sconosciuto",
      "Unknown5": "Sconosciuto",
      "Work": "Lavoro"
    }
  },
  "Dropzone": {
    "add file": "Aggiungi file",
    "drop file to upload": "Trascina il file per caricarlo",
    "drop files to upload": "Trascina i file per caricarli",
    "error uploading the file": "Si è verificato un errore durante il caricamento del file",
    "file invalid type": "Tipo di file non valido selezionato.",
    "file successfully uploaded": "File caricato con successo",
    "file syntax": "La sintassi dei file è la seguente:",
    "maximum file limit reached": "Limite massimo di file raggiunto.",
    "no image": "Nessuna immagine",
    "only one file can be attached": "È possibile allegare un solo file.",
    "or drop file to upload": "Oppure trascina il file per caricarlo",
    "or drop files to upload": "Oppure trascina i file per caricarli",
    "row limit exceeded": "Limite di importazione delle risorse raggiunto. Non è possibile importare più di {{rowLimit}} risorse.",
    "rows detected": "Righe nel file rilevate correttamente",
    "select file": "Seleziona file",
    "select file type": "Selezionare prima il tipo di file.",
    "select files": "Seleziona file",
    "select image": "Seleziona immagine:",
    "supported formats": "Formati supportati",
    "too long file name": "Il nome del file e' troppo lungo. Massimo di caratteri consentiti: {{maxLength}}",
    "too many files description": "Gli altri file possono essere caricati dopo aver caricato i file selezionati.",
    "too many files title": "Il limite massimo di file che è possibile allegare contemporaneamente è {{maxFiles}}."
  },
  "Error": {
    "error": "Errore",
    "message wait": "Abbi pazienza finché non risolviamo l'errore.",
    "title": "Si è verificato un errore!"
  },
  "Files": {
    "files header info tooltip": "I file scaricati vengono conservati in TachoSync per due anni, dopodiché vengono automaticamente rimossi dal sistema."
  },
  "Filter": {
    "company": "Azienda",
    "credit status": "Situazione creditizia",
    "deactivatedVehicles": "Veicoli disattivati",
    "device imei": "IMEI del dispositivo",
    "device status": "Stato del dispositivo",
    "driver": "Autista",
    "filtered by": "Filtrato per",
    "filters used": "Filtri utilizzati",
    "from to date": "{{fromDate}} a {{toDate}}",
    "last activity": "Ultima attività",
    "last download": "Ultimo download",
    "last download options": {
      "DueSoon": "Prossimamente",
      "NoDownloads": "Nessun download",
      "OnTime": "In orario",
      "Overdue": "Scaduto",
      "Undefined": "N/A"
    },
    "more filters": "Altri filtri",
    "noDeviceImei": "Nessun IMEI del dispositivo",
    "Not reserved": "Non riservato",
    "Reserved": "Riservato",
    "schedule": "Calendario",
    "schedule name": "Nome programma",
    "schedules": "Orari",
    "select date": "Seleziona la data",
    "select date and time": "Seleziona data e ora",
    "Select date range": "Seleziona intervallo di date",
    "status": "Stato",
    "table filters": "Filtri tabella",
    "vehicle number": "Numero del veicolo"
  },
  "General": {
    "Active": "Attivo",
    "Administrator": "Amministratore",
    "administrator role description": "Pieno controllo per creare, modificare ed eliminare tutte le risorse.",
    "analysis provider": "Fornitore di analisi",
    "analysis providers": "Fornitori di analisi",
    "api credential": "Credenziale API",
    "api credentials": "Credenziali API",
    "Available": "Disponibile",
    "Awaiting connection": "In attesa di connessione",
    "badge": {
      "connected badge tooltip text": "Connessione a TachoSync stabilita con successo e comunicazione attiva.",
      "deactivated badge tooltip text": "Questo veicolo è disattivato e non consumerà crediti.",
      "inactive badge tooltip text": "Non è mai stata stabilita una connessione con TachoSync.",
      "offline badge tooltip text": "Nessuna connessione con TachoSync nelle ultime 24 ore",
      "online badge tooltip text": "Connesso nelle ultime 24 ore"
    },
    "Blocked": "Bloccato",
    "BreakOrRest": "Pausa/Riposo",
    "business": "Azienda",
    "code expired": "La tua sessione è scaduta. Effettua nuovamente l'accesso.",
    "column": "colonna",
    "companies": "Aziende",
    "company": "Azienda",
    "Company administrator": "Amministratore aziendale",
    "Connected": "Connesso",
    "credits": "Crediti",
    "dashboard": "Dashboard",
    "Deactivated": "Disattivato",
    "Description": "Descrizione",
    "Disabled": "Disabilitato",
    "Disconnected": "Non connesso",
    "Drive": "Guida",
    "driver data": "Dati dei conducenti",
    "drivers": "Autisti",
    "DueSoon": "Prossimamente",
    "end": "Fine",
    "Expired": "Scaduto",
    "Failed": "Operazione non riuscita",
    "files": "File",
    "here": "qui",
    "history": "Cronologia",
    "Inactive": "Inattivo",
    "in progress": "in corso",
    "integration": "Integrazione",
    "integrations": "Integrazioni",
    "integrations/analysisProviders": "Fornitori di analisi",
    "integrations/apicredentials": "Credenziali API",
    "Interrupted": "Interrotto",
    "InvalidConfiguration": "Operazione non riuscita",
    "invitations": "Inviti",
    "latest version": "Ultima versione",
    "menu": "Menu",
    "NoDownloads": "Nessun download",
    "not assigned": "Non assegnato",
    "Not reserved": "Non riservato",
    "NotAvailable": "Non disponibile",
    "NotReserved": "Non riservato",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "in orario",
    "Pending": "In attesa",
    "requirements": "Requisiti",
    "Reserved": "Riservato",
    "row": "Riga",
    "schedule": "Calendario",
    "schedules": "Orari",
    "show older": "Mostra i più vecchi",
    "start": "Inizio",
    "Successful": "Con successo",
    "Teltonika support": "Assistenza Teltonika",
    "Teltonika Support": "Assistenza Teltonika",
    "teltonika support role description": "Accesso riservato per l'assistenza tecnica.",
    "Tooltip": {
      "accept beta terms": "Per continuare, scorri fino in fondo alla pagina e accetta i termini."
    },
    "unauthorized": "Impossibile autenticare l'utente",
    "Undefined": "N/A",
    "Unknown": "Sconosciuto",
    "Unknown4": "Sconosciuto",
    "Unknown5": "Sconosciuto",
    "User": "Utente",
    "user role description": "Accesso di base con autorizzazioni limitate.",
    "users": "Utenti",
    "vehicles": "Veicoli",
    "Work": "Lavoro",
    "year": "Anno"
  },
  "Languages": {
    "english": "Inglese",
    "french": "Francese",
    "language": "Lingua"
  },
  "Navigation": {
    "collapse menu": "Chiudi menu",
    "expand menu": "Espandi menu"
  },
  "News": {
    "create news": "Crea notizia",
    "delete": "Elimina",
    "edit": "Modifica",
    "publish": "Pubblica",
    "unpublished": "Non pubblicato"
  },
  "Notifications": {
    "notifications": "Notifiche"
  },
  "Password": {
    "account password": "Password account",
    "are you sure": "Sei sicuro?",
    "change": "Modifica",
    "change password": "Cambia password",
    "click to scan code": "Clicca qui per scansionare un codice QR",
    "click to type code": "Clicca qui per digitare manualmente il codice",
    "disable description confirmation": "Stai per disattivare l'autenticazione a due fattori. Ciò potrebbe compromettere la sicurezza del tuo account TachoSync. Sei sicuro di voler continuare?",
    "disable description send code": "Un codice a 6 cifre e' stato inviato alla tua app di autenticazione. Per motivi di sicurezza, inserici il codice generato nel campo sottostante.",
    "disable description send password": "Per motivi di sicurezza, reinserisci la tua password attuale.",
    "disable no access": "Se non hai più accesso all'app di autenticazione collegata a questo account, è necessario modificare la password per disattivare l'autenticazione a due fattori.",
    "disabled": "Disabilitato",
    "disabled two FA": "Autenticazione a due fattori disattivata con successo.",
    "enabled": "Abilitato",
    "enter": "Inserisci",
    "enter current password": "Inserisci la password attuale",
    "generate key description": "Per completare questa procedura e' necessaria un'app di autenticazione, come una delle seguenti:",
    "incorrect code": "Codice errato",
    "incorrect password": "Password errata",
    "lowercase letter": "Almeno una lettera minuscola (a-z)",
    "minimum characters": "Almeno {{maxNumber}} caratteri",
    "minimum digits": "Almeno un numero",
    "password": "Password",
    "password too long": "La password non può contenere più di {{maxNumber}} caratteri",
    "passwords must match": "Le password devono corrispondere",
    "reset password success": "La tua password è stata modificata.",
    "scan QR code": "Scansiona il codice QR con la tua app",
    "six digit code": "Codice a 6 cifre generato dalla tua app",
    "special character": "Almeno un carattere speciale (!@#$%^&*()-_=+)",
    "success description": "Hai abilitato con successo l'autenticazione a due fattori.",
    "two-factor authentication": "Autenticazione a due fattori",
    "two-factor authentication description": "L'autenticazione a due fattori è un ulteriore livello di sicurezza che verifica la tua identità tramite qualcosa che conosci (password) e qualcosa che possiedi (telefono, chiave di sicurezza).",
    "two-factor authentication enabled": "Autenticazione a due fattori abilitata con successo.",
    "two-factor authentication status": "L'autenticazione a due fattori è:",
    "type text code": "Digita il codice di testo nella tua app",
    "uppercase letter": "Almeno una lettera maiuscola (A-Z)"
  },
  "Schedules": {
    "activities from": "Attività da",
    "activities to": "Attività a",
    "apply button tooltip": "Seleziona almeno un {{resourceName}} e pianifica l'applicazione.",
    "confirm bulk quick schedule": "Stai per creare un programma rapido per i conducenti selezionati. Desideri continuare?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Hai selezionato degli autisti, ma non è stato scelto né applicato alcun programma. Sei sicuro di voler continuare?",
          "selected": "Hai selezionato un programma, ma non l'hai applicato. Desideri applicare il programma ai conducenti selezionati?"
        },
        "vehicles": {
          "not selected": "Hai selezionato dei veicoli, ma non è stato scelto né applicato alcun programma. Sei sicuro di voler continuare?",
          "selected": "Hai selezionato un programma, ma non l'hai applicato. Desideri applicare il programma ai veicoli selezionati?"
        }
      },
      "title": {
        "not selected": "Nessun programma selezionato o applicato.",
        "selected": "Orario non applicato."
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Sei sicuro di voler eliminare il programma “{{scheduleName}}”? Questa azione è irreversibile e avrà ripercussioni su tutti i conducenti a cui è stato assegnato questo programma.",
        "vehicles": "Sei sicuro di voler eliminare il programma “{{scheduleName}}”? Questa azione è irreversibile e avrà effetto su tutti i veicoli a cui è applicato questo programma."
      },
      "title": "Eliminare la pianificazione?"
    },
    "create new schedule": "Crea nuovo programma",
    "data types": "Tipi di dati",
    "days": "giorni",
    "details remove schedule": {
      "description": "Sei sicuro di voler rimuovere il programma “{{scheduleName}}”?",
      "title": "Rimuovere il programma?"
    },
    "download activities": {
      "date info tooltip": "L'intervallo di date dell'attività deve coprire almeno due giorni.",
      "tooltip text": "TachoSync utilizza un intervallo di download adattivo che garantisce la continuità regolando automaticamente il periodo di download in base all'ultimo recupero dati riuscito. Ciò riduce al minimo le lacune e assicura di disporre sempre dei dati più recenti, anche se un download programmato non viene completato per un paio di giorni."
    },
    "driver number": "Autista {{driverNum}}",
    "driver schedules": {
      "description": "Gli orari dei conducenti consentono di automatizzare il download dei dati del tachigrafo per i conducenti selezionati. Seleziona i conducenti a cui desideri applicare un orario. Scegli un orario dall'elenco e clicca su \"Applica\" per attivarlo. Puoi creare, modificare ed eliminare gli orari secondo necessità. Nota: ogni azienda può avere un massimo di 3 orari dei conducenti alla volta.",
      "description read-only": "I programmi dei conducenti consentono di automatizzare il download dei dati del tachigrafo per i conducenti selezionati. Gli amministratori aziendali possono creare, modificare ed eliminare i programmi in base alle esigenze.",
      "title": "Orari dei conducenti"
    },
    "due date": "Data di scadenza",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "Il programma globale verrà applicato automaticamente a tutti i conducenti appena aggiunti. Questa impostazione può essere modificata nelle impostazioni generali.",
          "not global": "Le modifiche apportate a questo programma avranno effetto su tutti i conducenti a cui è applicato il programma."
        },
        "vehicles": {
          "global": "Il programma globale verrà applicato automaticamente a tutti i veicoli appena aggiunti. È possibile modificarlo nelle impostazioni generali.",
          "not global": "Le modifiche apportate a questo programma avranno effetto su tutti i veicoli a cui è applicato il programma."
        }
      },
      "title": {
        "global": "Calendario globale",
        "not global": "Modifica programma"
      }
    },
    "enter days": "Inserisci i giorni",
    "every": "Ogni",
    "fail reason": "Motivo dell'errore",
    "file types": {
      "Activities": "Attività",
      "DetailedSpeed": "Velocità dettagliata",
      "EventsAndFaults": "Eventi e guasti",
      "Overview": "Panoramica",
      "TechnicalData": "Dati tecnici"
    },
    "global schedule": {
      "connected to root company": "Collegato al calendario globale della società madre.",
      "global icon info": "Il programma globale verrà applicato automaticamente a tutti i {{specificGlobalSchedule}} appena registrati. È possibile disattivare questa opzione nelle impostazioni aziendali.",
      "info": {
        "edit driver schedule": "Il programma globale verrà applicato automaticamente a tutti i conducenti appena registrati. È possibile disattivare questa opzione nelle impostazioni aziendali.",
        "edit schedule": "Il programma globale verrà applicato automaticamente a tutti i {{ variableName }} appena registrati. È possibile disattivare questa opzione nelle impostazioni aziendali.",
        "edit vehicle schedule": "Il programma globale verrà applicato automaticamente a tutti i veicoli appena registrati. È possibile disattivare questa opzione nelle impostazioni aziendali."
      },
      "inherited settings": "Le impostazioni di calendario globali della società principale vengono automaticamente ereditate da tutte le società controllate.",
      "not configured description": "Premere il pulsante Modifica per avviare la configurazione della pianificazione globale.",
      "not configured description read-only": "I dettagli del programma saranno visibili una volta configurato.",
      "not configured title": "Calendario globale non configurato.",
      "not connected to root company": "Non collegato al calendario globale della società madre."
    },
    "include driver data": "Includi i dati dei conducenti",
    "include driver data tooltip": "Selezionare se la pianificazione rapida deve scaricare anche i dati della carta del conducente per i conducenti attualmente inseriti nel tachigrafo al momento dell'esecuzione.\n<ul><li>Nessuno – Verranno scaricati solo i dati del veicolo (VU).</li><li>Conducente 1 / Conducente 2 – Scarica i dati dallo slot del tachigrafo selezionato se è presente una carta del conducente.</li><li>Entrambi i conducenti – Scarica i dati da entrambi gli slot se sono presenti delle tessere.</li></ul>Se al momento dell'esecuzione non è inserita alcuna carta del conducente nello slot selezionato, i dati del conducente non verranno scaricati.",
    "max number reached": "Hai raggiunto il numero massimo di pianificazioni consentite.",
    "name not valid": "Il nome del programma non può contenere più di {{maxNumber}} caratteri",
    "next attempt": "Prossimo tentativo",
    "next date": "Prossima data",
    "next date and time": "Data e ora successive",
    "next due date": "Prossima scadenza",
    "quick schedule": {
      "description": "Seleziona i tipi di dati che desideri scaricare.",
      "driver schedule quick download new": "Crea una pianificazione una tantum per il download dei file dei conducenti. Verrà eseguita non appena il conducente si connette all'applicazione.",
      "info banner": {
        "drivers": "Questa e' una pianificazione una tantum. Il download dei dati del conducente verrà avviato non appena verrà rilevata la connessione del conducente a TachoSync.",
        "vehicles": "Questa e' una pianificazione una tantum. Il download dei dati del veicolo verrà avviato non appena verrà rilevata la connessione del veicolo a TachoSync."
      },
      "success banner": "La pianificazione è stata completata, può essere rimossa cliccando su \"Rimuovi pianificazione\"",
      "title": "pianificazione rapida",
      "vehicle schedule quick download deactivated": "Non è possibile avviare una pianificazione rapida su veicoli disattivati. Se desideri avviare una nuova pianificazione rapida, attiva prima il veicolo.",
      "vehicle schedule quick download new": "Crea una pianificazione una tantum per il download dei file del veicolo. Verrà eseguita non appena il veicolo si connette all'applicazione."
    },
    "repeat": "Ripeti",
    "repeat every": "Ripeti ogni",
    "repeat period": {
      "Biweekly": "Ogni 14 giorni",
      "Custom": "Personalizzato",
      "Daily": "Giornaliero",
      "Every28Days": "Ogni 28 giorni",
      "Every90Days": "Ogni 90 giorni",
      "EveryDays": "Ogni {{count}} giorni",
      "Hourly": "Orario",
      "Monthly": "Mensile",
      "Weekly": "Ogni 7 giorni"
    },
    "schedule details": "Dettagli di “{{scheduleName}}”",
    "select date": "Seleziona la data",
    "start date": "Data di inizio",
    "start date and time": "Data e ora di inizio",
    "vehicle schedules": {
      "description": "Le pianificazioni dei veicoli consentono di automatizzare il download dei dati del tachigrafo per i veicoli selezionati. Seleziona i veicoli a cui desideri applicare una pianificazione. Scegli una pianificazione dall'elenco e clicca su \"Applica\" per attivarla. Puoi creare, modificare ed eliminare le pianificazioni secondo necessità. Nota: ogni azienda può avere un massimo di 3 pianificazioni dei veicoli alla volta.",
      "description read-only": "Le pianificazioni dei veicoli consentono di automatizzare il download dei dati del tachigrafo per i veicoli selezionati. Gli amministratori aziendali possono creare, modificare ed eliminare le pianificazioni in base alle esigenze.",
      "download data activities tooltip hourly": "Le attivita' relative alla giornata odierna verrano scaricate.",
      "download data activities tooltip monthly": "Le attività saranno scaricate per l'intero mese precedente a ciascuna data di esecuzione",
      "download data activities tooltip multiple": "Le attività saranno scaricate relative agli ultimi {{repeatDays}} giorni precedenti ogni data di esecuzione",
      "download data activities tooltip single": "Le attività saranno scaricate relative all'ultimo giorno precedente ogni data di esecuzione",
      "title": "Orari dei veicoli"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "L'IMEI deve essere composto da 15 caratteri",
      "find device": "Trova dispositivo",
      "no vehicle found": "Nessun veicolo trovato",
      "no vehicle found description": "Veicolo non trovato. Prova a inserire l'IMEI di un altro dispositivo.",
      "only numbers": "Valgono solo i caratteri numerici",
      "search for vehicles by their IMEI": "Ricerca dei veicoli tramite l'IMEI del dispositivo",
      "search vehicle IMEI": "Cerca IMEI del dispositivo"
    },
    "search": "Cerca...",
    "search child company": "Cerca società controllata",
    "search company name": "Cerca nome azienda",
    "search in driverFiles": "Ricerca per autista o ID autista",
    "search in drivers": "Ricerca per nome o ID autista",
    "search in integrations": "Cerca per nome",
    "search in users": "Cerca per e-mail",
    "search in vehicleFiles": "Ricerca per IMEI o VRN del dispositivo FM",
    "search in vehicles": "Ricerca per IMEI o VRN del dispositivo FM"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Utilizza il codice visualizzato nella schermata accanto per verificare il tuo account.",
        "description modal": "Utilizza quel codice per verificare il tuo account.",
        "title": "Premendo \"Invia codice\", verrà inviato un codice univoco a <1>{{email}}</1>."
      },
      "select authentication type": {
        "authentication app description": "Ottieni un codice univoco da un'app come Microsoft Authenticator o Google Authenticator.",
        "description": "Per garantire la sicurezza del tuo account e dei dati dei clienti, ti invitiamo a utilizzare una delle seguenti opzioni per configurare l'autenticazione a due fattori.",
        "description modal": "Seleziona il metodo di autenticazione che preferisci.",
        "email": "E-mail",
        "email description": "Ogni volta che provi ad accedere, ti invieremo un codice monouso al tuo indirizzo e-mail.",
        "recommended": "Consigliato",
        "title": "L'autenticazione a due fattori (2FA) è obbligatoria per tutti gli utenti di TachoSync.",
        "title modal": "Seleziona il metodo di autenticazione"
      },
      "send email code": {
        "description": "Inserisci il codice nel campo sottostante e premi \"Verifica\" per procedere.",
        "enter code": "Inserisci il codice per verificare l'indirizzo e-mail.",
        "title": "È stato inviato un codice univoco a <1>{{email}}</1>.",
        "verification code": "Codice di verifica"
      },
      "send otp code": {
        "click to scan code": "Clicca qui per scansionare un codice QR",
        "click to type code": "Clicca qui per digitare manualmente il codice",
        "incorrect code": "Codice errato",
        "scan QR code": "Scansiona il codice QR con la tua app",
        "six digit code": "Codice a 6 cifre generato dalla tua app",
        "title": "Per completare questa procedura è necessaria un'app mobile di autenticazione, ad esempio: <1>Microsoft Authenticator</1> o <2>Google Authenticator</2>.",
        "type text code": "Digita il codice di testo nella tua app"
      },
      "success message": {
        "alert": "Autenticazione a due fattori abilitata con successo.",
        "description": "Ti chiederemo un codice di autenticazione ogni volta che effettuerai l'accesso con la tua e-mail e la tua password.",
        "title": "Hai abilitato con successo l'autenticazione a due fattori.",
        "title modal": "Autenticazione a due fattori abilitata!"
      },
      "title": {
        "authentication app": "App di autenticazione",
        "authentication email": "Email di autenticazione",
        "is enabled": "Autenticazione a due fattori abilitata.",
        "protect your account": "Proteggi il tuo account TachoSync"
      }
    }
  },
  "Selector": {
    "client company": "Azienda cliente",
    "companies": "Aziende ({{companyCount}})",
    "company selector": "Selezione azienda"
  },
  "Settings": {
    "CCA file size": "Dimensione del file: 83,5 MB",
    "change password": "Cambia password",
    "company card authenticator": "Autenticatore della carta aziendale",
    "email notifications": {
      "credits purchased": "Crediti acquistati",
      "low credits alerts": "Avvisi di credito in esaurimento",
      "title": "Notifiche via e-mail",
      "tooltip": "Gestisci quali e-mail relative al credito desideri ricevere."
    },
    "feature switches": "funzionalità",
    "file format settings": {
      "description": "Scegli in quale formato visualizzare i file del tachigrafo. I formati disponibili sono quello europeo (.DDD), quello francese (.V1B per i dati del veicolo e .C1B per i dati del conducente) e quello spagnolo (.TGD).",
      "title": "Impostazioni del formato dei file"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Impostazioni generali",
    "security": "Sicurezza",
    "time settings": {
      "date display format tooltip": "Seleziona un formato di visualizzazione della data all'interno di TachoSync.\nEs.: GG-MM-AAAA = 14-05-2024",
      "description": "Imposta automaticamente il fuso orario in base alla tua posizione attuale oppure scegli il fuso orario che preferisci e il formato in cui verranno visualizzati tutti i timestamp.",
      "time and date format toggle": "Imposta automaticamente il formato di data e ora",
      "title": "Impostazioni dell'ora"
    },
    "tutorials": "Tutorial",
    "version": "Versione"
  },
  "Table": {
    "activity period": "Periodo di attività",
    "Automatic initial Driver Download": "Download automatico dei dati iniziali del conducente",
    "Automatic initial Vehicle Download": "Download automatico dei dati iniziali del veicolo",
    "card name": "Nome",
    "card number": "ID conducente",
    "cardnumber": "ID conducente",
    "comment": "Commento",
    "company": "Azienda",
    "connection status": "Stato della connessione",
    "created at": "Creato alle",
    "created by": "Creato da",
    "credit status": "Situazione creditizia",
    "data types": "Tipi di dati",
    "day ago": "1 giorno fa",
    "days ago": "{{daysNum}} giorni fa",
    "description": "Descrizione",
    "device imei": "IMEI del dispositivo",
    "device imei empty": "Il veicolo non ha un IMEI associato. È necessario un IMEI valido per la connessione del dispositivo e il download dei file. Vai su \"Modifica veicolo\" e aggiungi un IMEI valido per consentire il download dei file del veicolo.",
    "device status": "Stato del dispositivo",
    "downloaded at": "Scaricato alle",
    "driver": "Autista",
    "driver name": "Nome dell'autista",
    "drivers name": "Nome degli autisti",
    "email": "E-mail",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Aggiungi integrazione",
          "driver files": "Aggiungi file autista",
          "drivers": "Aggiungi autista",
          "integrations": "Aggiungi integrazione",
          "integrations api": "Aggiungi integrazione",
          "users": "Invita utente",
          "vehicle files": "Aggiungi file veicolo",
          "vehicles": "Aggiungi veicolo"
        },
        "reset view": "Reimposta visualizzazione"
      },
      "no initial results": {
        "description": {
          "analysis providers": "Non appena i fornitori di servizi di analisi saranno aggiunti a TachoSync, \npotrai visualizzarne l'elenco qui.",
          "companies": "Non appena verranno aggiunte le aziende a TachoSync, potrai visualizzarne l'elenco qui",
          "company cards": "Non appena verranno aggiunte le carte aziendali, potrai visualizzarne l'elenco qui.",
          "driver files": "Non appena verranno aggiunti i file degli autisti a TachoSync, potrai visualizzarne l'elenco qui",
          "drivers": "Non appena verranno aggiunti gli autisti a TachoSync, potrai visualizzarne l'elenco qui.",
          "integrations": "Non appena verranno aggiunte le integrazioni a TachoSync, potrai visualizzarne l'elenco qui",
          "integrations api": "Non appena verranno create le chiavi API per la tua azienda, potrei visualizzarne l'elenco qui",
          "users": "Non appena verranno aggiunti gli utenti a TachoSync, potrai visualizzarne l'elenco qui",
          "users invitations": "Non appena verranno invitati gli utenti su TachSync, potrai visualizzarne l'elenco qui",
          "vehicle files": "Non appena verranno aggiunti i file dei veicoli su TachoSync, potrai visualizzarne l'elenco qui",
          "vehicles": "Non appena verranno aggiunti i veicoli a TachoSync, potrai visualizzarne l'elenco qui"
        },
        "title": {
          "analysis providers": "Non sono ancora disponibili fornitori di analisi",
          "companies": "La tabella delle aziende è vuota",
          "company cards": "La tabella delle carte aziendali è vuota",
          "driver files": "La tabella dei file dei conducenti è vuota",
          "drivers": "La tabella dei conducenti è vuota",
          "integrations": "Nessuna integrazione disponibile al momento",
          "integrations api": "Nessuna chiave API disponibile al momento",
          "users": "La tabella degli utenti è vuota",
          "users invitations": "La tabella degli inviti utente è vuota",
          "vehicle files": "La tabella dei file dei veicoli è vuota",
          "vehicles": "La tabella dei veicoli è vuota"
        }
      },
      "no results found": {
        "description": "Prova una parola chiave o un filtro diverso per ottenere più \nrisultati.",
        "title": "Nessun risultato trovato"
      }
    },
    "enable": "Abilita",
    "expiration date": "Data di scadenza",
    "expired integration tooltip": "L'integrazione è scaduta e non può essere abilitata",
    "file name": "Nome del file",
    "Global schedule": "Calendario globale",
    "imei": "IMEI",
    "invitation status": "Stato dell'invito",
    "invited at": "Invitato a",
    "invited by": "invitato da",
    "last activity": "Ultima attività",
    "last connected": "ultima volta connesso",
    "last connection": "Ultima connessione",
    "last download": "Ultimo download",
    "last download date": "Ultimo download: {{date}}",
    "last event": "Ultimo evento",
    "last vehicle used": "Ultimo veicolo utilizzato",
    "method": "Metodo",
    "name": "Nome",
    "next download": "prossimo download",
    "No schedule applied": "Nessuna pianificazione applicata",
    "No schedules": "Nessuna pianificazione",
    "number": "Numero",
    "Overdue": "Scaduto",
    "parent company": "Società madre",
    "plate number": "Targa",
    "provider": "Fornitore",
    "Quick schedule": "Calendario rapido",
    "role": "Ruolo",
    "rows per page": "Righe per pagina",
    "schedule": "Calendario",
    "schedules": "calendari",
    "seen at": "visto alle",
    "select columns to show": "Seleziona le colonne da visualizzare",
    "show details": {
      "companies": "Mostra i dettagli dell'azienda",
      "drivers": "Mostra i dettagli del conducente",
      "integrations": "Mostra i dettagli dell'integrazione",
      "vehicles": "Mostra i dettagli del veicolo"
    },
    "status": "Stato",
    "today": "Oggi",
    "updated at": "Aggiornato alle",
    "vehicle": "Veicolo",
    "vehicle name": "Nome del veicolo",
    "vehicle number": "VRN",
    "vehicles": "Veicoli"
  },
  "Tabs": {
    "analysis providers": "Fornitori di analisi",
    "api": "API",
    "invitations": "Inviti",
    "sftp": "SFTP",
    "users": "Utenti"
  },
  "Tooltip": {
    "delete company action": "Una o più aziende selezionate hanno società controllate e non possono essere eliminate. Per eliminare quelle selezionate, è necessario prima eliminare tutte le società controllate.",
    "no action permission": "Non disponi dei permessi necessari per eseguire questa operazione",
    "parent company": "Il numero massimo di livelli consentiti in un albero aziendale è {{maxAllowedLevels}}. L'azienda “{{companyName}}” si trova al {{maxAllowedLevels}}° livello e non è possibile aggiungere altre aziende controllate."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Per aggiungere una nuova scheda aziendale, clicca sul pulsante \"<strong>Aggiungi nuovo</strong>\" evidenziato. Quando appare la schermata di aggiunta dell'azienda, compila i campi necessari e clicca sul pulsante \"<strong>Salva</strong>\" per terminare.\n\nNota: l'ID della scheda aziendale si trova nell'Authenticator della scheda aziendale, nella colonna ID scheda.\n\nClicca su \"<strong>Avanti</strong>\" per continuare.",
          "title": "Aggiungi una nuova scheda aziendale"
        },
        "final step": {
          "content": "Tutte le carte aggiunte e i relativi dettagli saranno elencati nella sezione \"Carte aziendali\".\n\nNota: è possibile ripetere questo tutorial in qualsiasi momento andando su \"Impostazioni\" - \"Tutorial\". \n\nFare clic su \"<strong>Fine</strong>\" per completare il tutorial.",
          "title": "Dettagli della carta aziendale"
        },
        "first step": {
          "content": "Prima di aggiungere una scheda aziendale in TachoSync, assicurati di aver scaricato e installato Company Card Authenticator. Puoi farlo in qualsiasi momento dal menu Impostazioni.\n\nCompany Card Authenticator leggerà e mostrerà le informazioni delle schede aziendali inserite nel lettore di schede e consentirà l'autenticazione remota.\n\nClicca su \"<strong>Inizia</strong>\" per iniziare.",
          "title": "Autenticatore della carta aziendale"
        },
        "fourth step": {
          "content": "Sul lato destro è visibile il pannello dei dettagli dell'azienda. Qui puoi trovare tutte le informazioni relative all'azienda creata.\n\nFare clic su \"<strong>Avanti</strong>\" per continuare.",
          "title": "Dettagli aziendali"
        },
        "second step": {
          "content": "Utilizzando la barra laterale sinistra, esplora la pagina <strong>Aziende</strong> evidenziata.",
          "title": "Pagina delle aziende"
        },
        "third step": {
          "content": "Per visualizzare la schermata delle schede aziendali, è necessario prima cliccare su una delle aziende.\n\nPer questo tutorial, seleziona l'azienda evidenziata, che si trova in cima alla tabella.",
          "title": "Scegli un'azienda"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Per aggiungere una nuova scheda aziendale, clicca sul pulsante \"Aggiungi nuova\" evidenziato. Quando appare la schermata di aggiunta dell'azienda, compila i campi necessari e clicca sul pulsante \"Salva\" per terminare.\n\nNota: l'ID della scheda aziendale si trova nell'Autenticatore della scheda aziendale, nella colonna \"ID scheda\" della tabella.\n\nClicca su \"<strong>Avanti</strong>\" per continuare.",
          "title": "Aggiungi una nuova scheda aziendale"
        },
        "final step": {
          "content": "Tutte le schede aggiunte saranno elencate nella sezione evidenziata \"Schede aziendali\". Qui potrai visualizzare lo stato della scheda, la data di validità e l'ID.\n\nNota: puoi ripetere questo tutorial in qualsiasi momento andando su \"Impostazioni\" - \"Tutorial\". \n\nFai clic su \"<strong>Fine</strong>\" per completare il tutorial.",
          "title": "Dettagli della carta aziendale"
        },
        "first step": {
          "content": "Per prima cosa dobbiamo andare alla <strong>pagina</strong> <strong>Aziende</strong>, che si trova all'interno del menu in alto a destra.\n\nClicca sull'area evidenziata per aprire il <strong>menu</strong>.",
          "title": "Apri il menu"
        },
        "fourth step": {
          "content": "Qui puoi trovare tutte le informazioni relative all'azienda creata.\n\nClicca su “Avanti” per continuare.",
          "title": "Dettagli aziendali"
        },
        "second step": {
          "content": "Per aprire la <strong>pagina Aziende</strong>, clicca sull'area evidenziata.",
          "title": "Pagina delle aziende"
        },
        "third step": {
          "content": "Qui puoi vedere l'elenco di tutte le aziende.\nPer visualizzare la scheda di una di esse, apri la schermata <strong>dei dettagli dell'azienda</strong> cliccando sul pulsante evidenziato.",
          "title": "dettagli aggiuntivi"
        }
      },
      "name": "Aggiungi scheda aziendale"
    },
    "add vehicle": {
      "first step": {
        "content": "Per applicare un programma, è necessario aver aggiunto almeno un veicolo.\n\nAggiungiamo un veicolo premendo il pulsante \"<strong>Aggiungi veicolo</strong>\" evidenziato.\n\nNella schermata successiva, compila tutti i campi necessari e premi il pulsante \"<strong>Aggiungi</strong>\" per completare l'aggiunta del veicolo.",
        "title": "Nessun veicolo aggiunto"
      },
      "name": "Aggiungi veicolo"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Dopo aver selezionato un programma, si attiverà il pulsante \"Applica\".",
          "title": "Seleziona un programma da applicare"
        },
        "final step": {
          "content": "Fare clic sul pulsante \"<strong>Applica</strong>\".",
          "title": "Programma applicato con successo"
        },
        "first step": {
          "content": "Fare clic su \"Avanti\" per continuare.",
          "title": "Orari dei veicoli o dei conducenti"
        },
        "fourth step": {
          "content": "Clicca su un programma per applicarlo ai veicoli selezionati.\n\nClicca su “Avanti” per continuare",
          "title": "Seleziona un programma da applicare"
        },
        "second step": {
          "content": "Prima di applicare un programma, seleziona uno o più veicoli.\n\nPer questo tutorial, seleziona il <strong>primo veicolo nella tabella </strong> facendo clic sul pulsante evidenziato.",
          "title": "Seleziona un veicolo"
        },
        "third step": {
          "content": "Ora che hai selezionato un veicolo, il pulsante \"Programmi\" sarà attivo.\n\nClicca sul pulsante \"<strong>Programmi</strong>\" evidenziato per continuare.",
          "title": "Orari aperti"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Ora che hai selezionato un veicolo, il pulsante \"Programmi\" dovrebbe essere evidenziato.\n\nClicca sul pulsante \"<strong>Programmi</strong>\" evidenziato per continuare.",
          "title": "Orari aperti"
        },
        "final step": {
          "content": "Quando un programma viene applicato correttamente a un veicolo, il download dei dati avrà inizio all'ora prevista.\nTutti i programmi applicati a un veicolo o a un conducente verranno visualizzati nel pannello evidenziato \"<strong>Maggiori dettagli</strong>\".\n\nFare clic su \"<strong>Fine</strong>\" per completare il tutorial.",
          "title": "Programma applicato con successo"
        },
        "first step": {
          "content": "Gli orari dei veicoli si trovano nella pagina Veicoli, mentre quelli dei conducenti si trovano nella pagina Conducenti.\n\nPoiché la procedura è simile su entrambe le pagine, per questo tutorial selezioniamo la \"<strong>pagina Veicoli</strong>\" evidenziata.",
          "title": "Orari dei veicoli o dei conducenti"
        },
        "fourth step": {
          "content": "Per questo tutorial, selezioniamo il primo veicolo nella tabella, cliccando sul pulsante evidenziato.",
          "title": "Seleziona un veicolo"
        },
        "second step": {
          "content": "Poiché la procedura è simile su entrambe le pagine, per questo tutorial selezioniamo la \"<strong>pagina Veicoli</strong>\" evidenziata.",
          "title": "Pagina Veicoli"
        },
        "seventh step": {
          "content": "Dopo aver selezionato un programma, il pulsante \"<strong>Applica</strong>\" evidenziato diventerà attivo. Cliccandoci sopra, il programma verrà applicato al veicolo selezionato.\n\nClicca su \"<strong>Avanti</strong>\" per continuare.",
          "title": "Seleziona un programma da applicare"
        },
        "sixth step": {
          "content": "Dopo aver selezionato il veicolo, è possibile scegliere un programma da applicare cliccandoci sopra.\n\nClicca su “Avanti” per continuare",
          "title": "Seleziona un programma da applicare"
        },
        "third step": {
          "content": "È necessario selezionare prima uno o più veicoli, prima di applicare loro un programma.\nPer iniziare, clicca sul pulsante evidenziato “<strong>Seleziona</strong> righe”.",
          "title": "Apri strumento di selezione"
        }
      },
      "name": "Applica programma"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "Nel menu in alto, il selettore delle aziende consente di scegliere l'azienda con cui si desidera interagire in TachoSync.\nCiò è necessario quando si gestiscono più aziende.\n\nFare clic sul pulsante <strong>evidenziato</strong> per aprire il selettore delle aziende.",
          "title": "Apri il selettore delle aziende"
        },
        "second step": {
          "content": "La schermata di selezione dell'azienda consente di selezionare una specifica azienda con cui lavorare. Negli altri menu saranno visibili solo le risorse relative all'azienda selezionata. All'uscita da TachoSync verrà sempre salvata l'ultima selezione utilizzata.",
          "title": "Selezione azienda"
        }
      },
      "mobile": {
        "first step": {
          "content": "Nel menu in alto, il selettore delle aziende consente di scegliere l'azienda con cui si desidera interagire in TachoSync.\nCiò è necessario quando si gestiscono più aziende.\n\nFare clic sul pulsante <strong>evidenziato</strong> per aprire il selettore delle aziende.",
          "title": "Apri il selettore delle aziende"
        },
        "second step": {
          "content": "La schermata di selezione dell'azienda consente di selezionare una specifica azienda con cui lavorare. Negli altri menu saranno visibili solo le risorse relative all'azienda selezionata. All'uscita da TachoSync verrà sempre salvata l'ultima selezione utilizzata.",
          "title": "Selezione azienda"
        }
      },
      "name": "Selezione azienda"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Una volta creato un programma, è necessario applicarlo ai veicoli o ai conducenti selezionati. Consulta il tutorial \"<strong>Applica programma</strong>\" per sapere come applicare i programmi.\n\nFai clic su \"<strong>Avanti</strong>\" per continuare.",
          "title": "Orario non applicato"
        },
        "final step": {
          "content": "Congratulazioni, hai imparato a creare una pianificazione.\n\nOra impara come applicare una pianificazione agli elementi selezionati.\n\nClicca su “Fine” per completare il tutorial.",
          "title": "Crea un programma - completato"
        },
        "first step": {
          "content": "Una pianificazione è un programma predefinito che scarica automaticamente i dati del tachigrafo dai veicoli o dai conducenti in orari e intervalli specificati. Impostando una data di inizio, un'ora e una frequenza (ad esempio giornaliera), la pianificazione garantisce che i dati vengano raccolti in modo coerente senza la necessità di interventi manuali.\n\nFai clic su \"<strong>Inizia</strong>\" per iniziare.",
          "title": "Che cos'è un programma?"
        },
        "fourth step": {
          "content": "In questa schermata è possibile creare, modificare, mettere in pausa o rimuovere i programmi. Il primo spazio è sempre riservato al programma globale, che non può essere rimosso.",
          "title": "programmi"
        },
        "second step": {
          "content": "Gli orari dei veicoli si trovano nella pagina \"Veicoli\". Gli orari dei conducenti si trovano nella pagina \"Conducenti\".\n\nPoiché la procedura è simile in entrambe le pagine, per questo tutorial seleziona la pagina \"<strong>Veicoli</strong>\" evidenziata.",
          "title": "programmi dei veicoli o conducenti"
        },
        "third step": {
          "content": "È possibile creare e modificare un programma nella finestra Programmi in qualsiasi momento, indipendentemente dal fatto che siano stati aggiunti veicoli o conducenti.\n\nFare clic sul pulsante \"<strong>Programmi</strong>\" evidenziato per continuare.",
          "title": "Orari aperti"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "In questa schermata è possibile creare, modificare, mettere in pausa o rimuovere qualsiasi programma creato. Il primo spazio è sempre riservato al programma globale, che non può essere rimosso.",
          "title": "Orari"
        },
        "final step": {
          "content": "Congratulazioni, hai imparato a creare una pianificazione.\n\nInoltre, scopri come applicare una pianificazione agli elementi selezionati.\n\nFai clic su \"<strong>Fine</strong>\" per completare il tutorial.",
          "title": "Crea un programma - completato"
        },
        "first step": {
          "content": "Una pianificazione è un programma predefinito che scarica automaticamente i dati del tachigrafo dai veicoli o dai conducenti in orari e intervalli specificati. Impostando una data di inizio, un'ora e una frequenza (ad esempio giornaliera), la pianificazione garantisce che i dati vengano raccolti in modo coerente senza la necessità di un intervento manuale.\n\nFai clic su \"<strong>Inizia</strong>\" per iniziare.",
          "title": "Che cos'è un programma?"
        },
        "fourth step": {
          "content": "È possibile creare e modificare un programma nella finestra Programmi in qualsiasi momento, indipendentemente dal fatto che siano stati aggiunti veicoli o conducenti.\n\nFare clic sul pulsante \"<strong>Programmi</strong>\" evidenziato per continuare.",
          "title": "Orari aperti"
        },
        "second step": {
          "content": "Gli orari dei veicoli si trovano nella pagina Veicoli, mentre quelli dei conducenti si trovano nella pagina Conducenti.\n\nPer accedere a queste pagine, apriamo innanzitutto il <strong>menu</strong>.",
          "title": "Orari dei veicoli o dei conducenti"
        },
        "sixth step": {
          "content": "Una volta creato un programma, è necessario applicarlo ai veicoli o ai conducenti selezionati. Come eseguire questa operazione è spiegato in un altro tutorial “Applica<strong> programma</strong>”.\n\nFare clic su “Avanti” per continuare.",
          "title": "Orario non applicato"
        },
        "third step": {
          "content": "Poiché la procedura è simile su entrambe le pagine, per questo tutorial selezioniamo la \"pagina <strong>Veicoli</strong>\" evidenziata",
          "title": "Pagina Veicoli"
        }
      },
      "name": "Crea programma"
    }
  }
}
